/* Lithophane editor — shared engine (extracted from lithophane-widget.liquid).
   Product-specific values (variant id, backend, frame geometry) come from
   window.LITHO_CONFIG, set inline by each product section before this loads.
   Requires THREE (three.min.js) loaded first for the 3D preview. */
(function(){

// ── Per-product config (set inline by the section; see window.LITHO_CONFIG) ──
const CFG = window.LITHO_CONFIG || {};
const VARIANT_ID = CFG.variantId;
const API_BASE = CFG.apiBase || 'https://web-production-08fe2.up.railway.app';
const GEO = CFG.geometry || {};
const PLATE = CFG.previewPlate || null;   // real product photo to composite the lit design onto
// Shared verbiage (window.KOBLO_EDITOR_DEFAULTS.strings) — edit once, both
// editors follow. Every call passes the current copy as a fallback.
const STR = (window.KOBLO_EDITOR_DEFAULTS || {}).strings || {};
function T(k, fb){ return (STR[k] != null) ? STR[k] : fb; }
let previewPanelBox = null;               // {cx,cy,s} px in the composite canvas — where the nightlight sits (for the square cart thumbnail)

// ── Modal shell open/close ──
const shell = document.getElementById('lw-shell');
function openShell() {
  shell.classList.add('open');
  document.body.classList.add('lw-shell-lock');
  let el = shell;
  while (el) {
    el.style.setProperty('opacity', '1', 'important');
    el.style.setProperty('filter', 'none', 'important');
    el.style.setProperty('transform', 'none', 'important');
    el = el.parentElement;
  }
  // The canvas can only be measured correctly once the modal is actually
  // visible — sizing it at script-load time (while display:none) produces
  // a collapsed, meaningless size.
  requestAnimationFrame(() => {
    if (img) initCrop({ cropS: cropS/fitScale, cropX: cropX/cv.width, cropY: cropY/cv.width });
    else { sizeCanvas(); draw(); }
  });
}
function closeShell() {
  shell.classList.remove('open');
  document.body.classList.remove('lw-shell-lock');
  if (window.location.search.includes('edit=')) {
    const url = new URL(window.location.href);
    url.searchParams.delete('edit');
    url.searchParams.delete('cart_line');
    history.replaceState({}, '', url.toString());
  }
}
function openCartDrawer() {
  document.dispatchEvent(new CustomEvent('cart:open'));
  const b = document.getElementById('cart-icon-bubble');
  if (b) b.click();
}

// After finishing an edit, wipe the edit state so "Create My Design" starts a
// fresh design (the drawer's own Edit links are self-contained URLs, so this
// doesn't break re-editing). Only relevant for the drawer/fresh path.
function clearEditToFresh() {
  editJobId = null; editCartLineKey = null; editFrom = null;
  reservedJobId = null; reservedVariantId = null;   // the reserved variant was just consumed; next design re-reserves
  originalUploaded = false; originalUploadedRotation = null;   // its background clean.jpg belonged to that job
  const dnEl = document.getElementById('lw-design-name'); if (dnEl) dnEl.value = '';
  const u = new URL(window.location.href);
  u.searchParams.delete('edit'); u.searchParams.delete('cart_line'); u.searchParams.delete('from');
  history.replaceState({}, '', u.toString());
  // Revert the edit-mode UI back to a fresh "Add to Cart" design
  document.getElementById('lw-cart-btn-label').textContent = T('addToCart', 'Add to Cart');
  document.getElementById('lw-cart-btn-price').style.display = '';
  document.getElementById('lw-confirm-proceed').textContent = T('addToCart', 'Add to Cart');
  const stEl = document.getElementById('lw-status');
  if (stEl) { stEl.textContent = ''; stEl.className = 'lw-header-status'; }
  previewReady = false;                     // invalidate the stale 3D preview
  document.getElementById('lw-cart-btn').disabled = true;
  applySnapshot(getBlankSnapshot());        // blank the 2D design
  commitHistory();
  setMode('design');                        // back to the Design tab — hides the stale 3D preview pane
}

// Route the exit based on where the shopper opened this edit from:
//  • from the cart PAGE  → send them back to the cart page
//  • from the cart DRAWER (default) → reopen the drawer, then reset to fresh
function exitAfterEdit() {
  if (editFrom === 'cart') { window.location.href = '/cart'; return; }
  closeShell();
  openCartDrawer();
  clearEditToFresh();
}

// Leaving an EDIT via ✕/backdrop used to silently discard changes — confirm
// first. (A fresh design keeps its in-editor state after closing, so no warning
// is needed there.)
function confirmDiscardEdit(onDiscard) {
  let ov = document.getElementById('lw-editexit-ov');
  if (!ov) {
    ov = document.createElement('div');
    ov.id = 'lw-editexit-ov';
    ov.style.cssText = 'position:fixed;inset:0;z-index:1000002;background:rgba(0,0,0,.45);display:flex;align-items:center;justify-content:center;padding:20px';
    ov.innerHTML = '<div style="background:#fff;border-radius:14px;max-width:340px;width:100%;padding:20px 18px;box-shadow:0 12px 40px rgba(0,0,0,.25)">' +
      '<div style="font-weight:700;font-size:16px;margin-bottom:6px;color:#2c332f">Save your changes?</div>' +
      '<div style="font-size:13.5px;color:#555;line-height:1.45;margin-bottom:14px">You’ve made changes to this design that aren’t saved yet.</div>' +
      '<div style="display:flex;flex-direction:column;gap:8px">' +
      '<button type="button" id="lw-editexit-save" style="padding:11px;border-radius:9px;border:0;background:#2c332f;color:#fff;font-weight:600;cursor:pointer">Save Design</button>' +
      '<button type="button" id="lw-editexit-discard" style="padding:11px;border-radius:9px;border:1px solid #d8d4d4;background:#fff;color:#b03a2e;font-weight:600;cursor:pointer">Discard Changes</button>' +
      '<button type="button" id="lw-editexit-back" style="padding:11px;border-radius:9px;border:1px solid #d8d4d4;background:#fff;color:#2c332f;cursor:pointer">Keep Editing</button>' +
      '</div></div>';
    document.body.appendChild(ov);
  }
  ov.style.display = 'flex';
  const hide = () => { ov.style.display = 'none'; };
  ov.onclick = (e) => { if (e.target === ov) hide(); };
  document.getElementById('lw-editexit-back').onclick = hide;
  document.getElementById('lw-editexit-discard').onclick = () => { hide(); onDiscard(); };
  // Save = the normal Save Design flow (incl. the preview-first gate).
  document.getElementById('lw-editexit-save').onclick = () => { hide(); const b = document.getElementById('lw-cart-btn'); if (b) b.click(); };
}

// Closing the editor (X / backdrop): if we were editing, confirm then route by
// origin; otherwise just close.
function onShellClose() {
  if (editJobId && editDirty) confirmDiscardEdit(exitAfterEdit);
  else if (editJobId) exitAfterEdit();
  else closeShell();
}

window.openLithophaneModal = openShell;
window.closeLithophaneModal = closeShell;
document.getElementById('lw-shell-close').onclick = onShellClose;
document.getElementById('lw-shell-backdrop').onclick = onShellClose;

// Mobile overflow menu (Restart / Help)
const shellMenuBtn = document.getElementById('lw-shell-menu-btn');
const helpMenuBtn = document.getElementById('lw-top-help');
const shellMenu = document.getElementById('lw-shell-menu');
const toggleShellMenu = e => { e.stopPropagation(); shellMenu.hidden = !shellMenu.hidden; };
shellMenuBtn.onclick = toggleShellMenu;
document.getElementById('lw-mnav-restart').onclick = () => document.getElementById('lw-restart-design').click();

// Help / tips modal — opened from the ? (mobile), the sidebar Help (desktop),
// and the overflow menu.
const helpModal = document.getElementById('lw-help-modal');
function openHelp(e){ if (e) e.stopPropagation(); shellMenu.hidden = true; helpModal.classList.add('on'); }
function closeHelp(){ helpModal.classList.remove('on'); }
helpMenuBtn.onclick = openHelp;
const helpSidebarBtn = document.getElementById('lw-help-btn');
if (helpSidebarBtn) helpSidebarBtn.onclick = openHelp;
const helpMenuItem = document.getElementById('lw-menu-help');
if (helpMenuItem) helpMenuItem.onclick = openHelp;
document.getElementById('lw-help-close').onclick = closeHelp;
document.getElementById('lw-help-gotit').onclick = closeHelp;
helpModal.addEventListener('click', e => { if (e.target === helpModal) closeHelp(); });
document.addEventListener('click', e => {
  if (!shellMenu.hidden && !shellMenu.contains(e.target) && e.target !== shellMenuBtn && e.target !== helpMenuBtn && !helpMenuBtn.contains(e.target)) shellMenu.hidden = true;
});
// Top-bar undo/redo mirror the (now hidden on mobile) toolbar buttons.
document.getElementById('lw-top-undo').onclick = () => document.getElementById('lw-undo-btn').click();
document.getElementById('lw-top-redo').onclick = () => document.getElementById('lw-redo-btn').click();

// ── Edit-mode detection (from cart drawer/page "edit" links) ──
let editJobId = null, editCartLineKey = null, editFrom = null;
let editDirty = false, editHydrated = false;   // warn on ✕ only for REAL unsaved changes in edit mode
// Pre-minting: reserve a Shopify variant while the shopper designs, so add-to-cart
// doesn't wait ~1s for the mint. Filled by ensureReserved(); passed to /save.
let reservedJobId = null, reservedVariantId = null, reserveInFlight = false;
// The full-res original is pushed to R2 in the background as soon as we have a
// reserved job, so its bytes never sit on the add-to-cart click.
let originalUploaded = false, originalUploadedRotation = null, originalUploadExt = 'jpg';
let originalUploadInFlight = false, originalUploadSeq = 0;
function ensureReserved() {
  if (editJobId || reservedJobId || reserveInFlight) return;   // not on edits; once per session
  reserveInFlight = true;
  fetch(`${API_BASE}/reserve`, { method: 'POST' })
    .then(r => r.ok ? r.json() : null)
    .then(d => { if (d && d.job_id && d.variant_id) { reservedJobId = d.job_id; reservedVariantId = d.variant_id; uploadOriginalBg(); } })
    .catch(() => {})
    .finally(() => { reserveInFlight = false; });
}

// Upload the full-res, text-free source to the reserved job in the background.
// Runs after the reserve resolves and again after a rotate (which rebuilds the
// source). add-to-cart then skips re-sending it when the rotation still matches.
async function uploadOriginalBg() {
  if (editJobId || !reservedJobId || !img) return;
  const seq = ++originalUploadSeq;                 // newest request wins
  if (originalUploadInFlight) return;              // the running upload re-checks seq when it finishes
  originalUploadInFlight = true;
  const rot = rotation;                            // the source state we're capturing
  try {
    const blob = await getOriginalBlob();
    if (blob) {
      const fd = new FormData();
      fd.append('job_id', reservedJobId);
      fd.append('original', blob, 'original.jpg');
      const r = await fetch(`${API_BASE}/save-original`, { method: 'POST', body: fd });
      // Only mark current if no newer photo/rotation superseded us mid-flight —
      // otherwise a stale original could be skipped at checkout (wrong photo).
      if (r.ok && seq === originalUploadSeq) {
        const d = await r.json().catch(() => null);
        originalUploaded = true;
        originalUploadedRotation = rot;
        originalUploadExt = (d && d.clean_ext) || 'jpg';
      }
    }
  } catch (e) {
    /* stays false → add-to-cart falls back to sending the original inline */
  } finally {
    originalUploadInFlight = false;
    if (seq !== originalUploadSeq) uploadOriginalBg();   // a newer source queued during the upload
  }
}
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('edit')) {
  editJobId = urlParams.get('edit');
  editCartLineKey = urlParams.get('cart_line');
  editFrom = urlParams.get('from');   // 'drawer' | 'cart' — where the shopper opened Edit from
  document.getElementById('lw-cart-btn-label').textContent = T('saveDesign', 'Save Design');
  document.getElementById('lw-cart-btn-price').style.display = 'none';       // no price on "Save Design"
  document.getElementById('lw-confirm-proceed').textContent = T('saveDesign', 'Save Design'); // confirm button, not "Add to Cart"
  document.getElementById('lw-canvas-upload').style.display = 'none';        // don't flash the upload prompt while loading
  document.getElementById('lw-shell-loading').style.display = 'flex';
  openShell();
}

let img=null;             // the (possibly rotated) draw source used everywhere
let originalImg=null;     // the un-rotated uploaded image; `img` is derived from it
let rotation=0;           // 0/90/180/270 — baked into `img`, never sent to backend
let cropX=0, cropY=0, cropS=1, fitScale=1;
let drag=false, lx=0, ly=0, lp=null;
let touchStartX=0, touchStartY=0, touchMoved=false;
let lowRes=false;
let previewReady=false;
let mode='design';
let bgChoice='white';
let startedWithBg=false; // user chose "start with a background" instead of a photo
const bgColors = { white:'#ffffff', '25':'#bfbfbf', '50':'#808080', '75':'#404040', '100':'#000000',
                   frosted:'#8f8f8f' };   // frosted = solid fallback; drawBase paints the speckled pattern
// Frosted-gray surround, same recipe as the ornament's: a #8f8f8f base with fine
// speckle so it reads (and prints) as frosted glass rather than a flat tone.
// drawBase runs at three sizes — the design canvas, the 900px preview bake and
// the 1080px print bake — so the tile is scaled to the target canvas, otherwise
// the grain would be a different physical size in the editor than on the part.
let _frostTile = null;
function frostPattern(ctx, canvasW) {
  if (!_frostTile) {
    const pc = document.createElement('canvas'); pc.width = pc.height = 256;
    const px = pc.getContext('2d');
    px.fillStyle = '#8f8f8f'; px.fillRect(0, 0, 256, 256);
    for (let i = 0; i < 2600; i++) {
      const v = 123 + Math.floor(Math.random() * 40);      // ±20 around the base
      px.fillStyle = 'rgba(' + v + ',' + v + ',' + v + ',0.5)';
      px.fillRect(Math.random() * 256, Math.random() * 256, 1.6, 1.6);
    }
    _frostTile = pc;
  }
  const pat = ctx.createPattern(_frostTile, 'repeat');
  const k = canvasW / PRINT_PX;
  if (pat && pat.setTransform) { try { pat.setTransform(new DOMMatrix([k,0,0,k,0,0])); } catch(e){} }
  return pat;
}

let textColor1='dark', textAlign1='center';
let textColor2='dark', textAlign2='center';
let textFont1='Playfair Display', textFont2='Playfair Display';
let bold1=false, italic1=false, underline1=false;
let bold2=false, italic2=false, underline2=false;
let outline1=false, outline2=false;
let curvedEnabled=false, curveAmount=50, curveFlip=false;
let curvedEnabled2=false, curveAmount2=50, curveFlip2=false;

// Independent per-line position and size
let text1X=0.5, text1Y=0.72, text1Size=22;
let text2X=0.5, text2Y=0.88, text2Size=16;
// Optional text-box width as a fraction of the canvas (0 = auto: box hugs the
// text). Widening it gives the left/center/right alignment room to work.
let text1BoxW=0, text2BoxW=0;
let draggingText=null; // 'text1' | 'text2' | null
let dragOffX=0, dragOffY=0;
let selectedText=null; // 'text1' | 'text2' | null — shows the resize handle
let textRevealed=false; // mobile: whether the tap opened the tools (vs a drag)
const DEFAULT_TEXT = 'Your Text Here'; // placeholder for a freshly-added text layer
const MAX_CHARS = 40;

// ── Lithophane frame geometry (single source of truth) ──
// These MUST match the 3D mesh in renderPanel3D and the crop in getBlob. From the
// design's edge inward: the texture is pre-cropped by LITHO_CROP (the physical
// cut edge), then the mesh adds a flat border (LITHO_BT) and a chamfer
// (LITHO_CH) on top. So in *design-canvas* fractions:
//   • LITHO_CROP_FRAC  — physical cut edge (outside = trimmed off the part)
//   • BLEED_FRAC       — border ends / chamfer(bevel) begins  (~3.6%)
//   • SAFETY_FRAC      — chamfer ends / flat fully-lit image begins  (~7.2%)
const LITHO_H = GEO.H ?? 108, LITHO_BT = GEO.borderMM ?? 2, LITHO_CH = GEO.chamferMM ?? 4;   // mm: height/width, border, chamfer
const LITHO_CROP_FRAC = LITHO_BT / LITHO_H;        // = 2/108, the texture pre-crop (also getBlob/renderPanel3D)
const BLEED_FRAC  = LITHO_CROP_FRAC + (LITHO_BT / LITHO_H)             * (1 - 2*LITHO_CROP_FRAC);
const SAFETY_FRAC = LITHO_CROP_FRAC + ((LITHO_BT+LITHO_CH) / LITHO_H)  * (1 - 2*LITHO_CROP_FRAC);
// Print resolution: the generator resamples the printable panel at the mesh
// resolution, so the real detail ceiling is ~96mm ÷ 0.20mm ≈ 480px across. Below
// that the print upscales and softens; above it the extra pixels are discarded.
// (The 0.16mm layer height sets tonal depth, not XY resolution.) The upload + zoom
// warnings fire when the image's EFFECTIVE resolution feeding the panel drops under
// MIN_PANEL_PX — which also makes them zoom-aware (cropping in lowers it).
const GEN_MESH_MM  = GEO.meshMM ?? 0.20;                             // generation sampling (mm/px)
const PANEL_FRAC   = 1 - 2 * (LITHO_BT + LITHO_CH) / LITHO_H;        // printed panel / canvas ≈ 0.889
const MIN_PANEL_PX = Math.round(LITHO_H * PANEL_FRAC / GEN_MESH_MM); // ≈ 480px of source over the panel
const FIT_PANEL_FACTOR = PANEL_FRAC / (1 - 4/108);   // ≈ 0.923: panel px per source px at fit-to-frame
// Instead of always showing a "n/40" counter, stay silent until the user hits
// the limit, then show a brief notice (in red via .lw-char-max).
function setCharNotice(el, len){
  if (!el) return;
  if (len >= MAX_CHARS) { el.textContent = 'Max ' + MAX_CHARS + ' chars'; el.classList.add('lw-char-max'); }
  else { el.textContent = ''; el.classList.remove('lw-char-max'); }
}
let uiScale=1;          // backing-px-per-CSS-px for sizing selection handles
let resizingText=null;
let resizeAnchor={x:0,y:0};
let resizeStartDist=1;
let resizeStartSize=22;
let resizeHandle=null;   // the handle being dragged (corners resize font, mid-edges resize box width)
let resizeBoxFixedX=0;   // for width drags: the opposite edge that stays put
let resizeBoxNatW=1;     // for width drags: the text's natural width (min box width)
let hoveringDeleteBtn=false;

// ── Undo / Redo history — covers photo, background, and all text state ──
let historyStack = [];
let historyIndex = -1;
let restoringHistory = false;
let historyDebounceTimer = null;

function snapshotState() {
  return {
    imgSrc: originalImg ? originalImg.src : null,
    rotation,
    cropX, cropY, cropS, fitScale,
    bgChoice,
    text1: document.getElementById('lw-text-input').value,
    text2: document.getElementById('lw-text-input2').value,
    textColor1, textAlign1, textColor2, textAlign2,
    textFont1, textFont2,
    bold1, italic1, underline1, bold2, italic2, underline2,
    outline1, outline2,
    curvedEnabled, curveAmount, curveFlip, curvedEnabled2, curveAmount2, curveFlip2,
    text1X, text1Y, text1Size, text1BoxW,
    text2X, text2Y, text2Size, text2BoxW,
    shapes: shapes.map(s => ({...s})),
    nextShapeId,
  };
}

function applySnapshot(s) {
  restoringHistory = true;
  bgChoice = s.bgChoice;

  document.getElementById('lw-text-input').value = s.text1;
  document.getElementById('lw-text-input2').value = s.text2;
  setCharNotice(document.getElementById('lw-count-1'), s.text1.length);
  setCharNotice(document.getElementById('lw-count-2'), s.text2.length);
  textColor1 = s.textColor1; textAlign1 = s.textAlign1;
  textColor2 = s.textColor2; textAlign2 = s.textAlign2;
  textFont1 = s.textFont1; textFont2 = s.textFont2;
  bold1 = !!s.bold1; italic1 = !!s.italic1; underline1 = !!s.underline1;
  bold2 = !!s.bold2; italic2 = !!s.italic2; underline2 = !!s.underline2;
  outline1 = !!s.outline1; outline2 = !!s.outline2;
  document.getElementById('lw-outline1-toggle').checked = outline1;
  document.getElementById('lw-outline2-toggle').checked = outline2;
  curvedEnabled = !!s.curvedEnabled; curveAmount = s.curveAmount != null ? s.curveAmount : 50; curveFlip = !!s.curveFlip;
  curvedEnabled2 = !!s.curvedEnabled2; curveAmount2 = s.curveAmount2 != null ? s.curveAmount2 : 50; curveFlip2 = !!s.curveFlip2;
  text1X = s.text1X; text1Y = s.text1Y; text1Size = s.text1Size; text1BoxW = s.text1BoxW || 0;
  text2X = s.text2X; text2Y = s.text2Y; text2Size = s.text2Size; text2BoxW = s.text2BoxW || 0;
  shapes = (s.shapes || []).map(sh => ({...sh}));
  nextShapeId = s.nextShapeId || (shapes.reduce((m, sh) => Math.max(m, sh.id), 0) + 1);
  selectedShapeId = null;
  syncShapeColorButtons();

  document.getElementById('lw-font-select-1').value = textFont1;
  document.getElementById('lw-font-select-2').value = textFont2;
  syncStyleButtons();
  syncCurveUI();
  updateCurveAvailability();
  if (textColor1 === 'light') document.getElementById('lw-text1-light').click();
  else document.getElementById('lw-text1-dark').click();
  document.getElementById('lw-align1-' + textAlign1).click();
  if (textColor2 === 'light') document.getElementById('lw-text2-light').click();
  else document.getElementById('lw-text2-dark').click();
  document.getElementById('lw-align2-' + textAlign2).click();

  selectedText = null;
  // Clear any lingering text-selection UI (top editor / options) — otherwise a
  // restart or undo/redo taken while a text was selected leaves the editor bar
  // showing over a now-empty design.
  textRevealed = false;
  editingText = false;
  refreshTextUI();

  const finish = () => { restoringHistory = false; draw(); updateCartBtnState(); };

  if (s.imgSrc) {
    originalImg = new Image();
    originalImg.onload = () => {
      rotation = s.rotation || 0;
      applyRotation();
      cropX = s.cropX; cropY = s.cropY; cropS = s.cropS; fitScale = s.fitScale;
      sizeCanvas();
      showEditor();
      finish();
    };
    originalImg.src = s.imgSrc;
  } else {
    img = null; originalImg = null; rotation = 0;
    startedWithBg = false;
    document.getElementById('lw-photo-controls').style.display = 'none';
    document.getElementById('lw-pane-upload-btn').style.display = 'none';
    document.getElementById('lw-canvas-upload').style.display = '';
    lwSwitchTool('photo');
    updateToolGating();
    document.dispatchEvent(new CustomEvent('lw-text-select', { detail: { selected: false, editing: false } }));
    sizeCanvas();
    finish();
  }
}

function updateHistoryButtons() {
  const noUndo = historyIndex <= 0, noRedo = historyIndex >= historyStack.length - 1;
  document.getElementById('lw-undo-btn').disabled = noUndo;
  document.getElementById('lw-redo-btn').disabled = noRedo;
  document.getElementById('lw-top-undo').disabled = noUndo;
  document.getElementById('lw-top-redo').disabled = noRedo;
}

function commitHistory() {
  if (restoringHistory) return;
  clearTimeout(historyDebounceTimer);
  const snap = snapshotState();
  if (historyIndex >= 0 && JSON.stringify(historyStack[historyIndex]) === JSON.stringify(snap)) return;
  historyStack = historyStack.slice(0, historyIndex + 1);
  historyStack.push(snap);
  if (editJobId && editHydrated) editDirty = true;   // a genuine change after edit-load
  historyIndex = historyStack.length - 1;
  if (historyStack.length > 60) { historyStack.shift(); historyIndex--; }
  updateHistoryButtons();
  previewReady = false;          // a design change invalidates the rendered preview → must re-preview
  updateCartBtnState();          // content changed → refresh the Add-to-Cart enabled state
}

function scheduleHistoryCommit() {
  clearTimeout(historyDebounceTimer);
  historyDebounceTimer = setTimeout(commitHistory, 600);
}

document.getElementById('lw-undo-btn').onclick = () => {
  if (historyIndex <= 0) return;
  historyIndex--;
  applySnapshot(historyStack[historyIndex]);
  updateHistoryButtons();
};
document.getElementById('lw-redo-btn').onclick = () => {
  if (historyIndex >= historyStack.length - 1) return;
  historyIndex++;
  applySnapshot(historyStack[historyIndex]);
  updateHistoryButtons();
};

window.lwModalAccept = function() {
  document.getElementById('lw-lowres-modal').classList.remove('on');
  document.getElementById('lw-warn-editor').classList.add('on');
  showEditor();
}
window.lwModalDismiss = function() {
  document.getElementById('lw-lowres-modal').classList.remove('on');
  document.getElementById('lw-file').value = '';
  img = null; lowRes = false;
}

const cv  = document.getElementById('lw-cv');
const ctx = cv.getContext('2d');
const selCv = document.getElementById('lw-sel-cv');
const selCtx = selCv.getContext('2d');
const SH  = document.getElementById('lw-sh');
const SV  = document.getElementById('lw-sv');
let snapHtimer=null, snapVtimer=null;

// ── Design / Preview mode toggle ──
function setMode(m) {
  mode = m;
  // Leaving the design canvas drops any text selection so the top editor
  // (which lives above the canvas) doesn't linger over Preview.
  if (m !== 'design' && selectedText) selectText(null);
  document.getElementById('lw-mode-design').classList.toggle('active', m === 'design');
  document.getElementById('lw-mode-preview').classList.toggle('active', m === 'preview');
  document.getElementById('lw-mode-pane-design').classList.toggle('on', m === 'design');
  document.getElementById('lw-mode-pane-preview').classList.toggle('on', m === 'preview');
  document.getElementById('lw-workspace').classList.toggle('lw-preview-mode', m === 'preview');
  document.querySelector('.lw').classList.toggle('lw-preview', m === 'preview');
  document.getElementById('lw-undo-btn').style.display = m === 'preview' ? 'none' : '';
  document.getElementById('lw-redo-btn').style.display = m === 'preview' ? 'none' : '';
  document.getElementById('lw-top-undo').style.display = m === 'preview' ? 'none' : '';
  document.getElementById('lw-top-redo').style.display = m === 'preview' ? 'none' : '';
  if (m === 'preview') buildComposite();
  else if (img) initCrop({cropS: cropS/fitScale, cropX: cropX/cv.width, cropY: cropY/cv.width});
  else { sizeCanvas(); draw(); }
  updateMnav();
}
document.getElementById('lw-mode-design').onclick = () => setMode('design');
document.getElementById('lw-mode-preview').onclick = () => setMode('preview');

// ── Sidebar tool switching (Photo / Text) ──
const lwTools = { photo: document.getElementById('lw-tool-photo'), text: document.getElementById('lw-tool-text'), shapes: document.getElementById('lw-tool-shapes') };
const lwPanes = { photo: document.getElementById('lw-tool-pane-photo'), text: document.getElementById('lw-tool-pane-text'), shapes: document.getElementById('lw-tool-pane-shapes') };
function lwSwitchTool(name) {
  // Photo is the required first step — Text/Shapes stay locked until a photo
  // is added or the user starts with a background.
  if (name !== 'photo' && !img && !startedWithBg) return;
  Object.keys(lwTools).forEach(k => {
    lwTools[k].classList.toggle('active', k === name);
    lwPanes[k].classList.toggle('on', k === name);
  });
  // On mobile, leaving the text tool clears any text selection so the top
  // editor and per-text options hide with it. (Desktop keeps its selection.)
  if (isMobile() && name !== 'text' && selectedText) {
    selectText(null);
  }
  if (typeof updateMnav === 'function') updateMnav();
}
lwTools.photo.onclick = () => lwSwitchTool('photo');
lwTools.text.onclick = () => lwSwitchTool('text');
lwTools.shapes.onclick = () => lwSwitchTool('shapes');

// ── Mobile step nav: Photo · Text · Preview ──
function mnavCurrentStep() {
  if (mode === 'preview') return 'preview';
  return lwTools.text.classList.contains('active') ? 'text' : 'photo';
}
function mnavGoTo(step) {
  const unlocked = !!img || startedWithBg;
  if ((step === 'text' || step === 'preview') && !unlocked) return;
  if (step === 'preview') { setMode('preview'); }
  else {
    if (mode !== 'design') setMode('design');
    // Tapping the Text tab always lands on the add/view overview, not the
    // formatting tools for a currently-selected text.
    if (step === 'text' && selectedText) selectText(null);
    lwSwitchTool(step);
  }
  updateMnav();
}
function updateMnav() {
  const cur = mnavCurrentStep();
  ['photo','text','preview'].forEach(s => document.getElementById('lw-mnav-'+s).classList.toggle('active', s === cur));
  const locked = !img && !startedWithBg;
  ['text','preview'].forEach(s => {
    const b = document.getElementById('lw-mnav-'+s);
    b.disabled = locked; b.classList.toggle('lw-mnav-locked', locked);
  });
}
document.getElementById('lw-mnav-photo').onclick = () => mnavGoTo('photo');
document.getElementById('lw-mnav-text').onclick = () => mnavGoTo('text');
document.getElementById('lw-mnav-preview').onclick = () => mnavGoTo('preview');

// Text/Shapes stay disabled until a photo has been added.
function updateToolGating() {
  const enabled = !!img || startedWithBg;
  ['text','shapes'].forEach(t => {
    const btn = lwTools[t];
    if (!btn) return;
    btn.disabled = !enabled;
    btn.classList.toggle('lw-sidebar-btn--disabled', !enabled);
  });
  if (typeof updateMnav === 'function') updateMnav();
}
updateToolGating();

// ── Selection-driven text editing (top editor + contextual options) ──
// A text object's content is edited in a top-anchored bar (so the keyboard
// never covers the canvas); its formatting options live in the bottom pane
// and show only while that text is selected and you're not actively typing.
const lwRoot = document.querySelector('.lw');
const topEditor = document.getElementById('lw-top-editor');
const topInput = document.getElementById('lw-top-text-editor');
const topCount = document.getElementById('lw-top-editor-count');
const addPanel = document.getElementById('lw-text-add-panel');
const textListEl = document.getElementById('lw-text-list');
const textGroup1 = document.getElementById('lw-text-group-1');
const textGroup2 = document.getElementById('lw-text-group-2');
const addTextBtn = document.getElementById('lw-add-text-btn');
let editingText = false;
function isMobile(){ return window.matchMedia('(max-width:820px)').matches; }

function layerInputId(k){ return k === 'text1' ? 'lw-text-input' : 'lw-text-input2'; }
function layerValue(k){ return document.getElementById(layerInputId(k)).value; }

function renderTextList(){
  textListEl.innerHTML = '';
  ['text1','text2'].forEach(k => {
    const v = layerValue(k);
    if (!v) return;
    const row = document.createElement('div');
    row.className = 'lw-text-list-row';
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'lw-text-list-item';
    b.textContent = v.replace(/\n/g, ' ');
    // Selecting a line from the list just selects it + shows its tools; to edit
    // the text you then tap it on the canvas (which opens the editor).
    b.onclick = () => selectText(k, true);
    const del = document.createElement('button');
    del.type = 'button';
    del.className = 'lw-text-list-del';
    del.setAttribute('aria-label', 'Delete this text');
    del.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/></svg>';
    del.onclick = () => deleteTextLayer(k);
    row.appendChild(b);
    row.appendChild(del);
    textListEl.appendChild(row);
  });
  addTextBtn.style.display = (layerValue('text1') && layerValue('text2')) ? 'none' : '';
}

function deleteTextLayer(k){
  document.getElementById(layerInputId(k)).value = '';
  setCharNotice(document.getElementById(k === 'text1' ? 'lw-count-1' : 'lw-count-2'), 0);
  if (k === 'text1') updateCurveAvailability();
  if (selectedText === k) selectText(null);
  else { refreshTextUI(); draw(); }
  commitHistory();
}

// Visibility is driven entirely by classes on .lw; the mobile patch's media
// query is what actually shows/hides these, so desktop is unaffected.
function refreshTextUI(){
  const sel = selectedText;
  // "shown" = the tools (top editor + options) are up. On mobile that only
  // happens on a tap (textRevealed); a drag selects for moving without them.
  const shown = !!sel && textRevealed;
  lwRoot.classList.toggle('lw-text-selected', shown);
  lwRoot.classList.toggle('lw-text-editing', shown && editingText);
  lwRoot.classList.toggle('lw-sel-text1', shown && sel === 'text1');
  lwRoot.classList.toggle('lw-sel-text2', shown && sel === 'text2');
  // On mobile the undo/redo/close controls hide only while the top editor bar
  // is actually open (editing), so it can own the whole row (input + live
  // character count). When a text is merely selected they stay visible.
  if (isMobile()) {
    const vis = (shown && editingText) ? 'hidden' : '';
    ['lw-top-actions','lw-shell-close'].forEach(id => {
      const el = document.getElementById(id); if (el) el.style.visibility = vis;
    });
  }
  if (!sel){ editingText = false; renderTextList(); }
  if (shown){
    const v = layerValue(sel);
    if (topInput.value !== v) topInput.value = v;
    setTopCount(v.length);
  }
}
// Live "n/40" counter for the top editor (turns red at the limit).
function setTopCount(len){
  topCount.textContent = len + '/' + MAX_CHARS;
  topCount.classList.toggle('lw-char-max', len >= MAX_CHARS);
}

function selectText(k, reveal){
  selectedShapeId = null;
  selectedText = k;
  textRevealed = !!k && (reveal !== false);
  if (k){
    if (isMobile() && textRevealed) lwSwitchTool('text');
    if (k === 'text1') updateCurveAvailability();
  } else {
    editingText = false;
  }
  refreshTextUI();
  draw();
  document.dispatchEvent(new CustomEvent('lw-text-select', { detail: { selected: !!k && textRevealed, editing: editingText } }));
}

// Grow the editor's textarea to fit its content (2+ lines) so nothing is
// clipped. Only meaningful while the bar is visible (scrollHeight needs layout).
function autoGrowTopInput(){
  topInput.style.height = 'auto';
  topInput.style.height = topInput.scrollHeight + 'px';
}
topInput.addEventListener('input', () => {
  if (!selectedText) return;
  const hidden = document.getElementById(layerInputId(selectedText));
  hidden.value = topInput.value;
  hidden.dispatchEvent(new Event('input', { bubbles: true }));  // reuse existing render/autofit/history
  setTopCount(topInput.value.length);
  autoGrowTopInput();
});
topInput.addEventListener('focus', () => {
  if (!selectedText) return;
  editingText = true;
  refreshTextUI();
  // Re-opening the untouched placeholder highlights it all so the first
  // keystroke replaces it. Defer the select so mobile browsers don't re-place
  // the caret at the tap point right after focusing (which would drop it).
  if (topInput.value === DEFAULT_TEXT) {
    const ta = topInput;
    setTimeout(() => { try { ta.setSelectionRange(0, ta.value.length); } catch (e) {} }, 0);
  }
  document.dispatchEvent(new CustomEvent('lw-text-select', { detail: { selected: true, editing: true } }));
});
topInput.addEventListener('blur', () => {
  editingText = false;
  refreshTextUI();
  document.dispatchEvent(new CustomEvent('lw-text-select', { detail: { selected: !!selectedText, editing: false } }));
});
// Open the top editor bar to type. It's display:none until we're in the
// editing state, and a display:none input can't be focused — so switch on
// editing (which reveals the bar via refreshTextUI) BEFORE calling focus().
function openTopEditor(){
  if (!selectedText) return;
  textRevealed = true;   // the editor only shows when the text is revealed
  editingText = true;
  refreshTextUI();       // reveal the bar first (a display:none input can't be measured/focused)
  autoGrowTopInput();    // size it to any existing multi-line content
  topInput.focus();
  document.dispatchEvent(new CustomEvent('lw-text-select', { detail: { selected: true, editing: true } }));
}
// "Done" (✓) just finishes typing: dismiss the keyboard but keep this text
// selected so its formatting tools stay up (don't drop back to the add/list
// overview — that's what tapping the Text tab is for).
function finishTextEditing() {
  topInput.blur();
  editingText = false;
  refreshTextUI();
  draw();
  document.dispatchEvent(new CustomEvent('lw-open-sheet', { detail: { tool: 'text' } }));
}
document.getElementById('lw-top-editor-done').onclick = finishTextEditing;

addTextBtn.onclick = () => {
  const k = !layerValue('text1') ? 'text1' : !layerValue('text2') ? 'text2' : null;
  if (!k) return;
  // Start new text at a small default size (10) so it isn't oversized.
  if (k === 'text1') text1Size = 10; else text2Size = 10;
  const hidden = document.getElementById(layerInputId(k));
  hidden.value = DEFAULT_TEXT;
  hidden.dispatchEvent(new Event('input', { bubbles: true }));
  selectText(k);
  // Open the top editor + keyboard straight away so you can type immediately.
  // openTopEditor reveals the bar before focusing (a display:none input can't be
  // focused), which avoids the earlier keyboard-race.
  if (isMobile()) openTopEditor();
  else { refreshTextUI(); try { hidden.focus(); hidden.select(); } catch (e) {} }   // highlight the placeholder so typing replaces it
  commitHistory();
};

refreshTextUI();


// ── Cart button is enabled once the 3D preview has rendered; clicking it
// opens a confirmation popup before the design is actually added ──
// True when the design has anything worth adding (photo, chosen background,
// text, or a shape). The Preview-first requirement is enforced in the cart
// click handler (jump to Preview with a toast) rather than by disabling.
function cartHasContent() {
  const t1 = (document.getElementById('lw-text-input') || {}).value || '';
  const t2 = (document.getElementById('lw-text-input2') || {}).value || '';
  return !!img || startedWithBg || t1.trim().length > 0 || t2.trim().length > 0
         || (typeof shapes !== 'undefined' && shapes.length > 0);
}
function updateCartBtnState() {
  const btn = document.getElementById('lw-cart-btn');
  btn.disabled = !cartHasContent();
  // Grey (but keep clickable) until previewed, so any change re-greys it.
  btn.classList.toggle('lw-needs-preview', !btn.disabled && !previewReady);
}

function updateConfirmBtnState() {}   // button stays clickable; approval is enforced on click with a message
document.getElementById('lw-confirm-cancel').onclick = () => document.getElementById('lw-confirm-modal').classList.remove('on');
document.getElementById('lw-confirm-retry').onclick = () => {
  document.getElementById('lw-confirm-loading').style.display = 'none';
  document.getElementById('lw-confirm-form').style.display = '';
};
// Popover anchored under the Add-to-Cart button (so the "preview first" nudge
// appears where the user clicked, not as a detached toast).
function showCartHint(text) {
  const btn = document.getElementById('lw-cart-btn'); if (!btn) return;
  let hint = document.getElementById('lw-cart-hint');
  if (!hint) { hint = document.createElement('div'); hint.id = 'lw-cart-hint'; hint.className = 'lw-cart-hint'; document.body.appendChild(hint); }
  hint.textContent = text; hint.style.display = 'block';
  const r = btn.getBoundingClientRect();
  // Flip above the button when there's no room below (mobile: the cart button
  // sits at the bottom of the screen, so "below" would be off-screen).
  const below = r.bottom + 12 + hint.offsetHeight <= window.innerHeight - 8;
  hint.classList.toggle('lw-cart-hint--above', !below);
  hint.style.top = (below ? r.bottom + 10 : r.top - hint.offsetHeight - 10) + 'px';
  hint.style.left = Math.max(8, Math.min(window.innerWidth - hint.offsetWidth - 8, r.right - hint.offsetWidth)) + 'px';
  clearTimeout(hint._t); hint._t = setTimeout(() => { hint.style.display = 'none'; }, 6000);
}
document.getElementById('lw-cart-btn').onclick = () => {
  if (!cartHasContent()) return;
  // First take them to the 3D preview (unless already seen), so they review the
  // real render before buying — with the nudge shown AT the button.
  if (!previewReady) {
    setMode('preview');
    const lbl = editJobId ? T('saveDesign', 'Save Design') : T('addToCart', 'Add to Cart');
    const tail = editJobId ? T('previewTailSave', 'to update your design.') : T('previewTailAdd', 'to add it to your cart.');
    const nudge = T('previewNudge', '👀 Here’s your 3D preview — click “{label}” again {tail}').replace('{label}', lbl).replace('{tail}', tail);
    showCartHint(nudge);
    return;
  }
  // Always open on the form view (in case a prior attempt left the loading view showing)
  document.getElementById('lw-confirm-form').style.display = '';
  document.getElementById('lw-confirm-loading').style.display = 'none';
  document.getElementById('lw-confirm-design').checked = false;
  updateConfirmBtnState();
  document.getElementById('lw-confirm-modal').classList.add('on');
};

// ── Canvas sizing ──
function computeSquareSize() {
  const container = document.getElementById('lw-adj-img');
  // clientWidth/Height include padding, so subtract it — the mobile layout pads
  // this box to frame the canvas (side + top margins) and the square must fit
  // inside that padding, not spill over it.
  const cs = getComputedStyle(container);
  const availW = container.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
  const availH = container.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
  return Math.max(120, Math.min(availW, availH) || 360);
}
function sizeCanvas() {
  const w = computeSquareSize();
  // Back the canvas at device resolution so the photo isn't upscaled/blurry
  // on high-DPR phones. All coordinate math uses cv.width, so returning the
  // backing size keeps crop/text/shape math consistent; only raw client-pixel
  // drag deltas need scaling (see clientToCanvas()).
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  uiScale = dpr; // selection handles/hit-targets are in backing px; scale them to stay finger-sized
  const px = Math.round(w * dpr);
  const wrap = document.getElementById('lw-crop-wrap');
  wrap.style.width = w + 'px';
  wrap.style.height = w + 'px';
  cv.width = cv.height = px;
  cv.style.width = cv.style.height = w + 'px';
  selCv.width = selCv.height = px;
  selCv.style.width = selCv.style.height = w + 'px';
  return px;
}
// Scale a raw client-pixel delta into canvas backing-store units.
function clientToCanvas() {
  const r = cv.getBoundingClientRect();
  return r.width ? cv.width / r.width : 1;
}

// ── Crop init (only meaningful once a photo is loaded, restores a saved
// crop for edit mode / window-resize using resolution-independent ratios) ──
function initCrop(saved) {
  requestAnimationFrame(() => {
    const w = sizeCanvas();
    const inner = w * (1 - 4/108);
    fitScale = Math.max(inner / img.width, inner / img.height);
    if (saved && saved.cropS) {
      cropS = saved.cropS * fitScale;
      cropX = (saved.cropX || 0) * w;
      cropY = (saved.cropY || 0) * w;
    } else {
      cropS = fitScale;
      cropX = 0; cropY = 0;
    }
    syncZoom();
    draw();
  });
}

// Source resolution over the printed panel, computed synchronously from the image
// (no dependency on the async crop scale). zoomRatio = cropS/fitScale (1 = fit).
function imagePanelResolutionPx(zoomRatio) {
  if (!img) return Infinity;
  return Math.min(img.width, img.height) * FIT_PANEL_FACTOR / (zoomRatio || 1);
}

// Rebuild `img` from `originalImg` rotated by `rotation`. At 0° we reuse the
// Image directly; otherwise we render into an offscreen canvas (which draws and
// measures just like an Image). Everything downstream (drawBase, exports) uses
// `img`, so the rotation bakes into the preview AND the saved image with no
// other changes and no backend awareness.
function applyRotation() {
  if (!originalImg) { img = null; return; }
  const rot = ((rotation % 360) + 360) % 360;
  if (rot === 0) { img = originalImg; return; }
  const ow = originalImg.width, oh = originalImg.height, swap = rot % 180 !== 0;
  const c = document.createElement('canvas');
  c.width  = swap ? oh : ow;
  c.height = swap ? ow : oh;
  const cx = c.getContext('2d');
  cx.translate(c.width / 2, c.height / 2);
  cx.rotate(rot * Math.PI / 180);
  cx.drawImage(originalImg, -ow / 2, -oh / 2);
  img = c;
}

// ±90° rotate. A quarter turn swaps width/height, so we refit to the frame —
// keeping the current zoom level but recentering (old pan doesn't map cleanly).
function rotateImage(delta) {
  if (!originalImg) return;
  const zoomRatio = (img && fitScale) ? (cropS / fitScale) : 1;
  rotation = (((rotation + delta) % 360) + 360) % 360;
  applyRotation();
  const w = cv.width, inner = w * (1 - 4/108);
  fitScale = Math.max(inner / img.width, inner / img.height);
  cropS = zoomRatio * fitScale;
  cropX = 0; cropY = 0;
  syncZoom();
  draw();
  commitHistory();
  originalUploaded = false; uploadOriginalBg();   // rotated source → refresh the background original
}

function slv(id) { return parseInt(document.getElementById(id).value) / 100; }

function drawBase(targetCtx, targetCanvas, cropOverride) {
  const s = targetCanvas.width;
  const cx = cropOverride ? cropOverride.cropX : cropX;
  const cy = cropOverride ? cropOverride.cropY : cropY;
  const cs = cropOverride ? cropOverride.cropS : cropS;
  targetCtx.fillStyle = bgChoice === 'frosted'
    ? frostPattern(targetCtx, s)
    : (bgColors[bgChoice] || '#ffffff');
  targetCtx.fillRect(0, 0, s, s);
  if (img) {
    const iw = img.width * cs, ih = img.height * cs;
    targetCtx.drawImage(img, (s-iw)/2 + cx, (s-ih)/2 + cy, iw, ih);
  }
  // The safety/bleed guides are drawn on the selection overlay (drawSafetyOverlay)
  // so they never bake into the exported image or the 3D texture.
}

function fontStyleString(bold, italic, fontSize, fontFamily) {
  const weight = bold ? '700' : '400';
  const it = italic ? 'italic ' : '';
  return `${it}${weight} ${fontSize}px '${fontFamily}', serif`;
}

// Draws text bowed along an arc. Positive radius bows the text upward (smile);
// negative radius bows it downward (frown) — same technique, mirrored.
function drawArcText(targetCtx, text, apexX, apexY, radius, fontStr, fillColor, strokeColor, strokeWidth) {
  if (!text) return;
  targetCtx.save();
  targetCtx.font = fontStr;
  targetCtx.textBaseline = 'middle';
  targetCtx.textAlign = 'center';
  targetCtx.fillStyle = fillColor;
  targetCtx.strokeStyle = strokeColor;
  targetCtx.lineWidth = strokeWidth;
  targetCtx.lineJoin = 'round';

  const chars = [...text];
  const charWidths = chars.map(ch => targetCtx.measureText(ch).width);
  const totalWidth = charWidths.reduce((a,b) => a+b, 0);
  const totalAngle = totalWidth / Math.abs(radius);

  targetCtx.translate(apexX, apexY + radius);
  let angle = -totalAngle / 2;
  for (let i = 0; i < chars.length; i++) {
    const chAngle = charWidths[i] / Math.abs(radius);
    angle += chAngle / 2;
    targetCtx.save();
    targetCtx.rotate(radius >= 0 ? angle : -angle);
    targetCtx.translate(0, -radius);
    if (strokeWidth > 0) targetCtx.strokeText(chars[i], 0, 0);
    targetCtx.fillText(chars[i], 0, 0);
    targetCtx.restore();
    angle += chAngle / 2;
  }
  targetCtx.restore();
}

function drawOneText(targetCtx, s, text, x, y, size, fontFamily, bold, italic, underline, curved, curveAmt, curveFlip, align, color, outline, boxW) {
  if (!text) return;
  const lines = text.split('\n');
  const minStrokePx = Math.ceil(0.35 * s / 108);
  const fontSize = Math.round(size * s / 100);
  const strokeW = Math.max(minStrokePx, fontSize * 0.035);
  const fillColor = color === 'dark' ? '#000' : '#fff';
  const outlineColor = color === 'dark' ? '#fff' : '#000';
  const outlineW = fontSize * 0.14;
  const drawW = outline ? outlineW : strokeW;
  const drawColor = outline ? outlineColor : fillColor;
  const fontStr = fontStyleString(bold, italic, fontSize, fontFamily);
  const px = x * s, py = y * s;

  if (curved && lines.length === 1) {
    const radius = KobloText.curveRadius(curveAmt, curveFlip, s);   // curvature-linear, 10–100, flip = frown
    drawArcText(targetCtx, lines[0], px, py, radius, fontStr, fillColor, drawColor, drawW);
    return;
  }

  targetCtx.save();
  targetCtx.font = fontStr;
  targetCtx.textAlign = align;
  targetCtx.textBaseline = 'middle';
  targetCtx.fillStyle = fillColor;
  targetCtx.strokeStyle = drawColor;
  targetCtx.lineWidth = drawW;
  targetCtx.lineJoin = 'round';
  // Align within the text box: a widened box (boxW) gives left/right room to
  // move; the default (auto) box hugs the text so alignment centers on px.
  const natW = Math.max(1, ...lines.map(l => targetCtx.measureText(l).width));
  const effBoxW = Math.max((boxW || 0) * s, natW);
  const anchorX = align === 'left'  ? px - effBoxW/2
                : align === 'right' ? px + effBoxW/2
                : px;
  const lineH = fontSize * 1.2;
  const totalH = lines.length * lineH;
  lines.forEach((line, i) => {
    const ty = py - totalH/2 + i * lineH + lineH/2;
    targetCtx.fillStyle = fillColor;
    targetCtx.strokeText(line, anchorX, ty);
    targetCtx.fillText(line, anchorX, ty);
    if (underline && line.trim()) {
      const m = targetCtx.measureText(line);
      const w = m.width;
      const ux = align === 'center' ? anchorX - w/2 : align === 'right' ? anchorX - w : anchorX;
      // Sit the underline a consistent gap below the actual glyph bottoms so it
      // renders the same on desktop and high-DPR mobile (no touching).
      const desc = (m.actualBoundingBoxDescent && isFinite(m.actualBoundingBoxDescent)) ? m.actualBoundingBoxDescent : fontSize * 0.37;
      const uy = ty + desc + fontSize * 0.14;
      const uh = Math.max(1, fontSize * 0.055);
      if (outline) { targetCtx.fillStyle = drawColor; targetCtx.fillRect(ux - drawW*0.4, uy - uh/2 - drawW*0.4, w + drawW*0.8, uh + drawW*0.8); }
      targetCtx.fillStyle = fillColor;
      targetCtx.fillRect(ux, uy - uh/2, w, uh);
    }
  });
  targetCtx.restore();
}

function drawTextOverlay(targetCtx, targetCanvas) {
  const s = targetCanvas.width;
  const txt1 = document.getElementById('lw-text-input').value;
  const txt2 = document.getElementById('lw-text-input2').value;
  drawOneText(targetCtx, s, txt1, text1X, text1Y, text1Size, textFont1, bold1, italic1, underline1, curvedEnabled, curveAmount, curveFlip, textAlign1, textColor1, outline1, text1BoxW);
  drawOneText(targetCtx, s, txt2, text2X, text2Y, text2Size, textFont2, bold2, italic2, underline2, curvedEnabled2, curveAmount2, curveFlip2, textAlign2, textColor2, outline2, text2BoxW);
}

// ── Text bounding box + selection/resize-handle rendering ──
function getTextInfo(key) {
  const text = key === 'text1' ? document.getElementById('lw-text-input').value : document.getElementById('lw-text-input2').value;
  const size = key === 'text1' ? text1Size : text2Size;
  const font = key === 'text1' ? textFont1 : textFont2;
  const bold = key === 'text1' ? bold1 : bold2;
  const italic = key === 'text1' ? italic1 : italic2;
  const x = key === 'text1' ? text1X : text2X;
  const y = key === 'text1' ? text1Y : text2Y;
  const align = key === 'text1' ? textAlign1 : textAlign2;
  const curved = key === 'text1' ? curvedEnabled : curvedEnabled2;
  const curveAmt = key === 'text1' ? curveAmount : curveAmount2;
  const flip = key === 'text1' ? curveFlip : curveFlip2;
  const boxW = key === 'text1' ? text1BoxW : text2BoxW;
  return { text, size, font, bold, italic, x, y, align, curved, curveAmt, curveFlip: flip, boxW };
}
function getTextBox(key) {
  const s = cv.width;
  const info = getTextInfo(key);
  const lines = (info.text || '').split('\n');
  const fontSize = Math.round(info.size * s / 100);
  ctx.font = fontStyleString(info.bold, info.italic, fontSize, info.font);
  const width = Math.max(1, ...lines.map(l => ctx.measureText(l).width));
  const lineH = fontSize * 1.2;
  const px = info.x * s, py = info.y * s;
  // Curved single-line text arcs above/below the baseline (sagitta); grow the
  // box vertically to enclose that bulge. drawArcText centers the arc on px.
  if (info.curved && lines.length === 1) {
    const R = Math.abs(KobloText.curveRadius(info.curveAmt, false, s));   // radius magnitude (matches drawOneText)
    const halfA = Math.min((width / R) / 2, Math.PI);                  // half sweep angle (width ≈ arc length)
    const sagitta = R * (1 - Math.cos(halfA));
    const height = lineH + sagitta;
    const top = info.curveFlip ? py - lineH/2 - sagitta : py - lineH/2;
    const left = px - width/2;
    return { left, top, width, height, cx: px, cy: top + height/2 };
  }
  const height = lines.length * lineH;
  // Box is centered on px with the effective width (widened box, or the text's
  // natural width when auto). Alignment moves the text within this box.
  const effBoxW = Math.max((info.boxW || 0) * s, width);
  const left = px - effBoxW/2;
  const top = py - height/2;
  return { left, top, width: effBoxW, height, cx: px, cy: py };
}
// Width (mid-edge) handles only apply to a selected, non-curved TEXT box —
// never shapes, and never curved text (which is always centered on its arc).
function widthHandlesActive(){
  if (!selectedText) return false;
  return !(selectedText === 'text1' ? curvedEnabled : curvedEnabled2);
}
// Corner handles resize the font; mid-edge handles resize the box width.
function getHandlePoints(box) {
  const pad = 6 * uiScale;
  const h = {
    tl: { x: box.left - pad, y: box.top - pad, cursor: 'nwse-resize' },
    tr: { x: box.left + box.width + pad, y: box.top - pad, cursor: 'nesw-resize' },
    bl: { x: box.left - pad, y: box.top + box.height + pad, cursor: 'nesw-resize' },
    br: { x: box.left + box.width + pad, y: box.top + box.height + pad, cursor: 'nwse-resize' },
  };
  if (widthHandlesActive()) {
    // Mid-edge handles widen the box (not the text) so alignment has room.
    h.rm = { x: box.left + box.width + pad, y: box.top + box.height/2, cursor: 'ew-resize', width: true };
    h.lm = { x: box.left - pad, y: box.top + box.height/2, cursor: 'ew-resize', width: true };
  }
  return h;
}
// The text's natural rendered width (min box width for a layer).
function getNaturalTextWidth(key){
  const s = cv.width;
  const info = getTextInfo(key);
  const lines = (info.text || '').split('\n');
  const fontSize = Math.round(info.size * s / 100);
  ctx.font = fontStyleString(info.bold, info.italic, fontSize, info.font);
  return Math.max(1, ...lines.map(l => ctx.measureText(l).width));
}
// Apply a resize drag: corner handles scale the font, mid-edge handles widen
// the box (keeping the opposite edge fixed and re-centering on the new box).
function applyResize(p){
  if (!resizingText) return;
  if (resizeHandle && resizeHandle.width) {
    const s = cv.width;
    let newW = Math.min(s, Math.max(resizeBoxNatW, Math.abs(p.x - resizeBoxFixedX)));
    const newCenterX = resizeHandle.corner === 'rm' ? resizeBoxFixedX + newW/2 : resizeBoxFixedX - newW/2;
    if (resizingText === 'text1') { text1BoxW = newW / s; text1X = newCenterX / s; }
    else { text2BoxW = newW / s; text2X = newCenterX / s; }
  } else {
    const dist = Math.hypot(p.x - resizeAnchor.x, p.y - resizeAnchor.y) || 1;
    const scale = dist / resizeStartDist;
    const newSize = Math.max(5, Math.min(60, resizeStartSize * scale));
    if (resizingText === 'text1') text1Size = newSize; else text2Size = newSize;
  }
}
function getDeleteButtonPos(box) {
  return { x: box.left + box.width + 18 * uiScale, y: box.top - 18 * uiScale };
}
// Selection hit-testing is shared with the ornament via KobloText (this logic
// was ported verbatim from here, so behavior is unchanged).
function selOpts(){ return { uiScale: uiScale, isMobile: isMobile(), widthHandles: widthHandlesActive() }; }
function hitTestHandleBox(box, px, py) {
  return KobloText.hitTestHandle(box, px, py, selOpts());
}
function hitTestDeleteBox(box, px, py) {
  return KobloText.hitTestDelete(box, px, py, { uiScale: uiScale, isMobile: isMobile() });
}
// White dashed border + white corner handles, each black-outlined so they
// stand out against both light and dark canvas backgrounds.
function drawSelectionBox(targetCtx, box, hovering, hoverLabel) {
  const o = selOpts(); o.hovering = hovering; o.hoverLabel = hoverLabel || 'Delete';
  KobloText.drawSelection(targetCtx, box, o);
}
// Selection UI is drawn to a separate overlay canvas stacked on top of the
// design canvas — this keeps the dashed outline / handles / delete button
// out of anything captured from `cv` (exports, the 3D preview texture, etc).
// Fill the square ring between an outer inset `o` and inner inset `i` (px).
// Vistaprint-style safety/bleed guides + a dark veil over everything outside the
// safety area. Overlay canvas only — never bakes into the export or 3D texture.
function drawSafetyOverlay(){
  const s = selCv.width, k = uiScale;
  const bleed = BLEED_FRAC * s;        // inner edge of the black border (~3.6%) — photos snap here
  const safe  = SAFETY_FRAC * s;       // inner DASHED safety line (~7.2%) — text snaps here
  selCtx.save();
  // Solid WHITE outer border = the picture frame excluding the chamfer: a filled
  // white band from the canvas edge in to the chamfer-start line. Its crisp inner
  // edge is where photos snap. Overlay canvas only — never bakes into the export.
  selCtx.setLineDash([]);
  selCtx.fillStyle = '#ffffff';
  selCtx.beginPath();
  selCtx.rect(0, 0, s, s);
  selCtx.rect(bleed, bleed, s-2*bleed, s-2*bleed);
  selCtx.fill('evenodd');
  // Solid BLACK line at the INNER edge of the white frame band (the bleed line)
  // — where the photo stops / snaps. Marks the visible edge of the image.
  const bo = Math.max(1, 1.5 * k);
  selCtx.strokeStyle = '#111';
  selCtx.lineWidth = bo;
  selCtx.strokeRect(bleed, bleed, s - 2*bleed, s - 2*bleed);
  // Inner DASHED safety line — soft green (text snap target).
  selCtx.setLineDash([5*k, 5*k]);
  selCtx.strokeStyle = 'rgba(34,197,94,0.55)'; selCtx.lineWidth = 1 * k;
  selCtx.strokeRect(safe, safe, s-2*safe, s-2*safe);
  selCtx.restore();
}
function drawSelectionOverlay() {
  selCtx.clearRect(0, 0, selCv.width, selCv.height);
  if (mode !== 'design') return;
  drawSafetyOverlay();
  if (selectedText) {
    const info = getTextInfo(selectedText);
    if (!info.text) return;
    drawSelectionBox(selCtx, getTextBox(selectedText), hoveringDeleteBtn, 'Delete Text');
  } else if (selectedShapeId) {
    const shape = getShape(selectedShapeId);
    if (!shape) return;
    drawSelectionBox(selCtx, getShapeBox(shape), hoveringDeleteBtn, 'Delete Shape');
  }
}

// ── Shapes ──
let shapes = [];
let nextShapeId = 1;
let selectedShapeId = null;
let draggingShapeId = null;
let resizingShapeId = null;
let shapeResizeAnchor = {x:0,y:0};
let shapeResizeStartDist = 1;
let shapeResizeStartSize = 0.2;
let shapeDragOffX = 0, shapeDragOffY = 0;

function getShape(id) { return shapes.find(s => s.id === id); }
function getShapeBox(shape, sizeOverride) {
  const s = sizeOverride || cv.width;
  const size = shape.size * s;
  const cx = shape.x * s, cy = shape.y * s;
  return { left: cx - size/2, top: cy - size/2, width: size, height: size, cx, cy };
}
function drawShape(targetCtx, shape, sizeOverride) {
  const box = getShapeBox(shape, sizeOverride);
  const fill = shape.color === 'dark' ? '#000' : '#fff';
  targetCtx.save();
  targetCtx.fillStyle = fill;
  if (shape.type === 'rect') {
    targetCtx.fillRect(box.left, box.top, box.width, box.height);
  } else if (shape.type === 'circle') {
    targetCtx.beginPath();
    targetCtx.ellipse(box.cx, box.cy, box.width/2, box.height/2, 0, 0, Math.PI*2);
    targetCtx.fill();
  } else if (shape.type === 'triangle') {
    targetCtx.beginPath();
    targetCtx.moveTo(box.cx, box.top);
    targetCtx.lineTo(box.left + box.width, box.top + box.height);
    targetCtx.lineTo(box.left, box.top + box.height);
    targetCtx.closePath();
    targetCtx.fill();
  }
  targetCtx.restore();
}
function drawShapesLayer(targetCtx, sizeOverride) {
  shapes.forEach(shape => drawShape(targetCtx, shape, sizeOverride));
}
function hitTestShape(px, py) {
  for (let i = shapes.length - 1; i >= 0; i--) {
    const box = getShapeBox(shapes[i]);
    if (px > box.left-8 && px < box.left+box.width+8 && py > box.top-8 && py < box.top+box.height+8) return shapes[i].id;
  }
  return null;
}
function addShape(type) {
  const shape = { id: nextShapeId++, type, x: 0.5, y: 0.5, size: 0.2, color: 'dark' };
  shapes.push(shape);
  selectedText = null;
  selectedShapeId = shape.id;
  syncShapeColorButtons();
  draw();
  commitHistory();
}
function deleteSelectedShape() {
  if (!selectedShapeId) return;
  shapes = shapes.filter(s => s.id !== selectedShapeId);
  selectedShapeId = null;
  draw();
  commitHistory();
}
function syncShapeColorButtons() {
  const shape = selectedShapeId ? getShape(selectedShapeId) : null;
  const color = shape ? shape.color : 'dark';
  document.getElementById('lw-shape-dark').className = 'lw-color-opt' + (color === 'dark' ? ' active-dark' : '');
  document.getElementById('lw-shape-light').className = 'lw-color-opt' + (color === 'light' ? ' active-light' : '');
}

function draw() {
  drawBase(ctx, cv);
  drawShapesLayer(ctx);
  drawTextOverlay(ctx, cv);
  drawSelectionOverlay();
  updateSizeVals();
}

function syncZoom() {
  const MAX_SCALE = fitScale * 3, MIN_SCALE = fitScale * 0.1;
  const offset = cropS >= fitScale
    ? Math.round((cropS - fitScale) / (MAX_SCALE - fitScale) * 100)
    : Math.round((cropS - fitScale) / (fitScale - MIN_SCALE) * 100);
  document.getElementById('lw-sl-z').value = Math.max(-100, Math.min(100, offset));
  document.getElementById('lw-v-z').value  = (cropS / fitScale).toFixed(2);
}

// Native source pixels feeding the printed panel at the current zoom. Cropping in
// (higher cropS) lowers it; at fit it's the whole photo mapped across the panel.
function panelResolutionPx() {
  if (!img || !cropS) return Infinity;
  return (cv.width / cropS) * PANEL_FRAC;
}
function checkZoomWarn() {
  if (!img) return;
  document.getElementById('lw-warn-zoom').classList.toggle('on', panelResolutionPx() < MIN_PANEL_PX);
}

// Position a snap guide line at a fraction (0..1) of the canvas, keeping the
// 2px line fully visible even at the very top/bottom/left/right edges (a line at
// exactly 100% would be clipped by the crop-wrap's overflow:hidden).
function snapLinePos(frac){
  if (frac <= 0.002) return '0px';
  if (frac >= 0.998) return 'calc(100% - 2px)';
  return 'calc(' + (frac*100).toFixed(3) + '% - 1px)';
}
function hideSnapGuides(){ SH.style.display='none'; SV.style.display='none'; }

// Photo-snap window in SCREEN pixels — the way Figma/Illustrator/PowerPoint do
// it, so the pull is a constant felt distance whatever the window size or DPR.
// A fraction of the canvas does NOT feel the same across editors: the two have
// different pixel bases and display scales, so an identical fraction was ~5px
// here and ~14px on the ornament. MUST match SNAP_PX in ornament-editor.js.
const SNAP_PX = 2;

// ── Photo snap — runs live during photo drag ──
function doSnap() {
  if (!img) return;
  const s = cv.width, iw = img.width*cropS, ih = img.height*cropS;
  const L = (s-iw)/2+cropX, R = L+iw, T = (s-ih)/2+cropY, B = T+ih;
  const SNAP_T = SNAP_PX * (s / (cv.clientWidth || s));   // screen px → canvas px
  // Edges snap to the outer SOLID (bleed) line so the photo fills the frame,
  // plus centre.
  const m = BLEED_FRAC * s, mo = 1 - BLEED_FRAC;

  let sh = false;
  if (Math.abs(T - m) < SNAP_T)        { cropY -= (T-m);      SH.style.top = snapLinePos(BLEED_FRAC); sh = true; }
  else if (Math.abs(B-(s-m)) < SNAP_T) { cropY -= (B-(s-m));  SH.style.top = snapLinePos(mo);         sh = true; }
  else if (Math.abs(cropY) < SNAP_T)   { cropY = 0;           SH.style.top = snapLinePos(0.5);        sh = true; }

  let sv = false;
  if (Math.abs(L - m) < SNAP_T)        { cropX -= (L-m);      SV.style.left = snapLinePos(BLEED_FRAC); sv = true; }
  else if (Math.abs(R-(s-m)) < SNAP_T) { cropX -= (R-(s-m));  SV.style.left = snapLinePos(mo);         sv = true; }
  else if (Math.abs(cropX) < SNAP_T)   { cropX = 0;           SV.style.left = snapLinePos(0.5);        sv = true; }

  SH.style.display = sh ? 'block' : 'none';
  SV.style.display = sv ? 'block' : 'none';

  clearTimeout(snapHtimer); clearTimeout(snapVtimer);
  if (sh) snapHtimer = setTimeout(() => { SH.style.display='none'; }, 600);
  if (sv) snapVtimer = setTimeout(() => { SV.style.display='none'; }, 600);
}

// ── Text-box snap — snaps the dragged text's edges to the print SAFETY lines
// (7.2%) and the canvas center, with live blue guides. Returns the snapped
// {nx,ny} (box-center fractions). ──
function doTextSnap(key, nx, ny) {
  const s = cv.width;
  const b = getTextBox(key);
  const curX = key === 'text1' ? text1X : text2X;
  const curY = key === 'text1' ? text1Y : text2Y;
  const dx = (nx - curX) * s, dy = (ny - curY) * s;
  const left = b.left + dx, right = b.left + b.width + dx;
  const top = b.top + dy, bottom = b.top + b.height + dy;
  const safeIn = SAFETY_FRAC, safeOut = 1 - SAFETY_FRAC;   // fractions
  const T = s * 0.018;

  let svFrac = null;
  if (Math.abs(left - safeIn*s) < T)       { nx += (safeIn*s - left)/s;   svFrac = safeIn; }
  else if (Math.abs(right - safeOut*s) < T){ nx += (safeOut*s - right)/s; svFrac = safeOut; }
  else if (Math.abs(nx*s - s/2) < T)       { nx = 0.5;                    svFrac = 0.5; }

  let shFrac = null;
  if (Math.abs(top - safeIn*s) < T)         { ny += (safeIn*s - top)/s;    shFrac = safeIn; }
  else if (Math.abs(bottom - safeOut*s) < T){ ny += (safeOut*s - bottom)/s; shFrac = safeOut; }
  else if (Math.abs(ny*s - s/2) < T)        { ny = 0.5;                    shFrac = 0.5; }

  if (svFrac != null) { SV.style.left = snapLinePos(svFrac); SV.style.display = 'block'; } else SV.style.display = 'none';
  if (shFrac != null) { SH.style.top  = snapLinePos(shFrac); SH.style.display = 'block'; } else SH.style.display = 'none';
  return { nx, ny };
}

// ── Hit-test which (if either) text line is under a canvas point ──
function hitTestText(px, py) {
  const candidates = ['text1','text2'];
  for (const key of candidates) {
    const info = getTextInfo(key);
    if (!info.text) continue;
    const box = getTextBox(key);
    if (px > box.left - 12 && px < box.left + box.width + 12 && py > box.top - 12 && py < box.top + box.height + 12) {
      return key;
    }
  }
  return null;
}
function hitTestHandle(px, py) {
  if (!selectedText) return null;
  const info = getTextInfo(selectedText);
  if (!info.text) return null;
  return hitTestHandleBox(getTextBox(selectedText), px, py);
}
function hitTestDelete(px, py) {
  if (!selectedText) return false;
  const info = getTextInfo(selectedText);
  if (!info.text) return false;
  return hitTestDeleteBox(getTextBox(selectedText), px, py);
}

function getCanvasPos(clientX, clientY) {
  const rect = cv.getBoundingClientRect();
  return {
    x: (clientX - rect.left) * (cv.width / rect.width),
    y: (clientY - rect.top) * (cv.height / rect.height)
  };
}

function deleteSelectedText() {
  if (!selectedText) return;
  const inputId = selectedText === 'text1' ? 'lw-text-input' : 'lw-text-input2';
  const countId = selectedText === 'text1' ? 'lw-count-1' : 'lw-count-2';
  document.getElementById(inputId).value = '';
  setCharNotice(document.getElementById(countId), 0);
  if (selectedText === 'text1') updateCurveAvailability();
  selectText(null);
  commitHistory();
}

function beginInteraction(p) {
  // On mobile the Photo tab only pans the photo — text/shapes can't be
  // selected or edited from here (switch to the Text tab for that).
  if (isMobile() && lwTools.photo.classList.contains('active')) return false;
  // Handle/delete of whichever object (text or shape) is currently selected
  if (selectedShapeId) {
    const shape = getShape(selectedShapeId);
    if (shape) {
      const box = getShapeBox(shape);
      if (hitTestDeleteBox(box, p.x, p.y)) { deleteSelectedShape(); return true; }
      const h = hitTestHandleBox(box, p.x, p.y);
      if (h) {
        resizingShapeId = selectedShapeId;
        shapeResizeAnchor = { x: box.cx, y: box.cy };
        shapeResizeStartDist = Math.hypot(p.x - box.cx, p.y - box.cy) || 1;
        shapeResizeStartSize = shape.size;
        return true;
      }
    }
  }
  if (hitTestDelete(p.x, p.y)) {
    deleteSelectedText();
    return true;
  }
  const handle = hitTestHandle(p.x, p.y);
  if (handle) {
    resizingText = selectedText;
    resizeHandle = handle;
    const box = getTextBox(selectedText);
    if (handle.width) {
      // Widen the box, keeping the opposite edge fixed.
      resizeBoxFixedX = handle.corner === 'rm' ? box.left : box.left + box.width;
      resizeBoxNatW = getNaturalTextWidth(selectedText);
    } else {
      resizeAnchor = { x: box.cx, y: box.cy };
      resizeStartDist = Math.hypot(p.x - box.cx, p.y - box.cy) || 1;
      resizeStartSize = selectedText === 'text1' ? text1Size : text2Size;
    }
    return true;
  }
  const hit = hitTestText(p.x, p.y);
  if (hit) {
    draggingText = hit;
    const curX = hit === 'text1' ? text1X : text2X;
    const curY = hit === 'text1' ? text1Y : text2Y;
    dragOffX = p.x/cv.width - curX;
    dragOffY = p.y/cv.height - curY;
    if (selectedText === hit && textRevealed) {
      // Already open — allow repositioning without closing the tools.
      selectedShapeId = null;
      draw();
    } else {
      // Select for dragging; a clean tap (no move) reveals the tools on touchend.
      selectText(hit, false);
    }
    return true;
  }
  const shapeHit = hitTestShape(p.x, p.y);
  if (shapeHit) {
    selectedText = null;
    selectedShapeId = shapeHit;
    syncShapeColorButtons();
    const shape = getShape(shapeHit);
    draggingShapeId = shapeHit;
    shapeDragOffX = p.x/cv.width - shape.x;
    shapeDragOffY = p.y/cv.height - shape.y;
    refreshTextUI();
    draw();
    return true;
  }
  // Tapping empty canvas only deselects if something was selected. Otherwise
  // (e.g. panning the photo on the Photo tab) do nothing — dispatching a
  // deselect here would wrongly close the mobile tool sheet.
  if (selectedText || selectedShapeId) selectText(null);
  return false;
}

// ── Mouse drag ──
cv.addEventListener('mouseleave', () => {
  if (!drag && !draggingText && !resizingText && !draggingShapeId && !resizingShapeId) cv.style.cursor = img ? 'grab' : 'default';
  if (hoveringDeleteBtn) { hoveringDeleteBtn = false; draw(); }
});
cv.addEventListener('mousedown', e => {
  // While editing text on mobile the tap that opened the editor is followed by
  // a synthetic mousedown on the canvas (~300ms later); letting it through
  // blurs the editor and dismisses the keyboard before the user can type.
  // Preventing default here keeps focus. Guard on the editor actually being
  // focused (activeElement) too, in case the focus event hasn't set editingText
  // yet. (Desktop keeps the top editor hidden, so drag is unaffected.)
  if (editingText || document.activeElement === topInput) { e.preventDefault(); return; }
  const p = getCanvasPos(e.clientX, e.clientY);
  if (!beginInteraction(p)) drag = true;
  lx = e.clientX; ly = e.clientY;
});
window.addEventListener('mousemove', e => {
  const p = getCanvasPos(e.clientX, e.clientY);
  if (resizingShapeId) {
    const dist = Math.hypot(p.x - shapeResizeAnchor.x, p.y - shapeResizeAnchor.y) || 1;
    const scale = dist / shapeResizeStartDist;
    const shape = getShape(resizingShapeId);
    if (shape) shape.size = Math.max(0.03, Math.min(0.7, shapeResizeStartSize * scale));
    draw(); return;
  }
  if (draggingShapeId) {
    const shape = getShape(draggingShapeId);
    if (shape) {
      shape.x = Math.max(0.03, Math.min(0.97, p.x/cv.width - shapeDragOffX));
      shape.y = Math.max(0.03, Math.min(0.97, p.y/cv.height - shapeDragOffY));
    }
    draw(); return;
  }
  if (resizingText) {
    applyResize(p);
    draw(); return;
  }
  if (draggingText) {
    let nx = p.x/cv.width - dragOffX;
    let ny = p.y/cv.height - dragOffY;
    const snapped = doTextSnap(draggingText, nx, ny);
    nx = Math.max(0.05, Math.min(0.95, snapped.nx));
    ny = Math.max(0.05, Math.min(0.95, snapped.ny));
    if (draggingText === 'text1') { text1X = nx; text1Y = ny; }
    else { text2X = nx; text2Y = ny; }
    draw(); return;
  }
  if (drag) {
    const sc = clientToCanvas();
    cropX += (e.clientX - lx) * sc;
    cropY += (e.clientY - ly) * sc;
    lx = e.clientX; ly = e.clientY;
    doSnap(); draw();
    return;
  }
  // Not interacting — update cursor feedback
  if (selectedText) {
    const handle = hitTestHandle(p.x, p.y);
    if (handle) {
      cv.style.cursor = handle.cursor;
      if (hoveringDeleteBtn) { hoveringDeleteBtn = false; draw(); }
      return;
    }
    if (hitTestDelete(p.x, p.y)) {
      cv.style.cursor = 'pointer';
      if (!hoveringDeleteBtn) { hoveringDeleteBtn = true; draw(); }
      return;
    }
  } else if (selectedShapeId) {
    const shape = getShape(selectedShapeId);
    if (shape) {
      const box = getShapeBox(shape);
      const handle = hitTestHandleBox(box, p.x, p.y);
      if (handle) {
        cv.style.cursor = handle.cursor;
        if (hoveringDeleteBtn) { hoveringDeleteBtn = false; draw(); }
        return;
      }
      if (hitTestDeleteBox(box, p.x, p.y)) {
        cv.style.cursor = 'pointer';
        if (!hoveringDeleteBtn) { hoveringDeleteBtn = true; draw(); }
        return;
      }
    }
  }
  if (hoveringDeleteBtn) { hoveringDeleteBtn = false; draw(); }
  cv.style.cursor = (hitTestText(p.x, p.y) || hitTestShape(p.x, p.y)) ? 'move' : (img ? 'grab' : 'default');
});
window.addEventListener('mouseup', () => {
  const wasInteracting = drag || draggingText || resizingText || draggingShapeId || resizingShapeId;
  if (draggingText) hideSnapGuides();
  drag=false; draggingText=null; resizingText=null; draggingShapeId=null; resizingShapeId=null;
  if (wasInteracting) commitHistory();
});

// ── Touch drag ──
// On mobile the photo can only be panned/zoomed while the Photo tool is
// active, so it can't be nudged by accident from the Text tab.
function photoEditAllowed(){ return !!img && (!isMobile() || lwTools.photo.classList.contains('active')); }
cv.addEventListener('touchstart', e => {
  if (e.touches.length === 1) {
    const p = getCanvasPos(e.touches[0].clientX, e.touches[0].clientY);
    touchStartX = e.touches[0].clientX; touchStartY = e.touches[0].clientY; touchMoved = false;
    if (!beginInteraction(p) && photoEditAllowed()) drag = true;
    lx = e.touches[0].clientX; ly = e.touches[0].clientY;
  }
}, {passive:true});
cv.addEventListener('touchmove', e => {
  e.preventDefault();
  if (e.touches.length === 1) {
    if (Math.hypot(e.touches[0].clientX - touchStartX, e.touches[0].clientY - touchStartY) > 10) touchMoved = true;
    const p = getCanvasPos(e.touches[0].clientX, e.touches[0].clientY);
    if (resizingShapeId) {
      const dist = Math.hypot(p.x - shapeResizeAnchor.x, p.y - shapeResizeAnchor.y) || 1;
      const scale = dist / shapeResizeStartDist;
      const shape = getShape(resizingShapeId);
      if (shape) shape.size = Math.max(0.03, Math.min(0.7, shapeResizeStartSize * scale));
      draw(); return;
    }
    if (draggingShapeId) {
      const shape = getShape(draggingShapeId);
      if (shape) {
        shape.x = Math.max(0.03, Math.min(0.97, p.x/cv.width - shapeDragOffX));
        shape.y = Math.max(0.03, Math.min(0.97, p.y/cv.height - shapeDragOffY));
      }
      draw(); return;
    }
    if (resizingText) {
      applyResize(p);
      draw(); return;
    }
    if (draggingText) {
      // Reveal this line's tools the instant the drag starts (not on release).
      if (!textRevealed && isMobile()) selectText(draggingText, true);
      let nx = p.x/cv.width - dragOffX;
      let ny = p.y/cv.height - dragOffY;
      const snapped = doTextSnap(draggingText, nx, ny);
      nx = Math.max(0.05, Math.min(0.95, snapped.nx));
      ny = Math.max(0.05, Math.min(0.95, snapped.ny));
      if (draggingText === 'text1') { text1X = nx; text1Y = ny; }
      else { text2X = nx; text2Y = ny; }
      draw(); return;
    }
    if (drag) {
      const sc = clientToCanvas();
      cropX += (e.touches[0].clientX - lx) * sc;
      cropY += (e.touches[0].clientY - ly) * sc;
      lx = e.touches[0].clientX; ly = e.touches[0].clientY;
      doSnap(); draw();
    }
  }
  if (e.touches.length === 2 && photoEditAllowed()) {
    const d = Math.hypot(e.touches[0].clientX-e.touches[1].clientX, e.touches[0].clientY-e.touches[1].clientY);
    if (lp) cropS *= d/lp;
    lp = d; cropS = Math.max(0.01, cropS);
    syncZoom(); checkZoomWarn(); draw();
  }
}, {passive:false});
cv.addEventListener('touchend', () => {
  const wasInteracting = drag || draggingText || resizingText || draggingShapeId || resizingShapeId;
  // Tapping/dragging a text SELECTS it and reveals its styling tools. Only a
  // clean tap on an ALREADY-selected (already-revealed) text opens the top
  // editor + keyboard — so selecting never jumps straight into typing.
  if (!resizingText && selectedText) {
    if (touchMoved) {
      if (!textRevealed) selectText(selectedText, true);   // drag → reveal tools
    } else if (!textRevealed) {
      selectText(selectedText, true);                       // 1st tap → select + reveal tools
    } else if (isMobile()) {
      openTopEditor();                                      // tap again (already selected) → editor
    }
  }
  if (draggingText) hideSnapGuides();
  drag=false; draggingText=null; resizingText=null; draggingShapeId=null; resizingShapeId=null; lp=null;
  if (wasInteracting) commitHistory();
});

// Low-res modal buttons — wired by id (shared editor-lowres-modal snippet).
document.getElementById('lw-lowres-change').onclick = window.lwModalDismiss;
document.getElementById('lw-lowres-accept').onclick = window.lwModalAccept;

// ── Photo upload (button + drag & drop onto the canvas) ──
document.getElementById('lw-upload-zone').onclick = () => document.getElementById('lw-file').click();
const uploadZoneEl = document.getElementById('lw-upload-zone');
uploadZoneEl.ondragover = e => { e.preventDefault(); uploadZoneEl.classList.add('over'); };
uploadZoneEl.ondragleave = () => uploadZoneEl.classList.remove('over');
uploadZoneEl.ondrop = e => { e.preventDefault(); uploadZoneEl.classList.remove('over'); if (e.dataTransfer.files[0]) loadFile(e.dataTransfer.files[0]); };
document.getElementById('lw-file').onchange = e => { if (e.target.files[0]) loadFile(e.target.files[0]); };

const cropWrapEl = document.getElementById('lw-crop-wrap');
cropWrapEl.ondragover  = e => { e.preventDefault(); };
cropWrapEl.ondrop      = e => { e.preventDefault(); if (e.dataTransfer.files[0]) loadFile(e.dataTransfer.files[0]); };

// On-canvas upload target (first-run) — the canvas itself is the drop zone.
const canvasUploadEl = document.getElementById('lw-canvas-upload');
// Tapping anywhere on the empty canvas opens the file picker; the background
// button is the only exception.
canvasUploadEl.onclick = () => document.getElementById('lw-file').click();
document.getElementById('lw-canvas-upload-bg').onclick = e => { e.stopPropagation(); ensureReserved(); startWithBackground(); };
document.getElementById('lw-pane-upload-btn').onclick = () => document.getElementById('lw-file').click();
canvasUploadEl.ondragover = e => { e.preventDefault(); canvasUploadEl.classList.add('over'); };
canvasUploadEl.ondragleave = () => canvasUploadEl.classList.remove('over');
canvasUploadEl.ondrop = e => { e.preventDefault(); canvasUploadEl.classList.remove('over'); if (e.dataTransfer.files[0]) loadFile(e.dataTransfer.files[0]); };

// Start a text-on-background design without a photo.
function startWithBackground() {
  startedWithBg = true;
  setBackground('white'); // text-only design: bright panel so dark text glows/reads
  document.getElementById('lw-canvas-upload').style.display = 'none';
  document.getElementById('lw-pane-upload-btn').style.display = '';
  updateToolGating();
  lwSwitchTool('photo');
  document.dispatchEvent(new CustomEvent('lw-open-sheet', { detail: { tool: 'photo' } }));
  draw();
  commitHistory();
}

function loadFile(f) {
  if (!f.type.match(/image\/(png|jpeg)/)) return;
  ensureReserved();   // pre-mint the SKU now, while they crop/add text/preview
  const r = new FileReader();
  r.onload = e => {
    img = new Image();
    img.onload = () => {
      originalImg = img; rotation = 0;   // fresh upload starts un-rotated
      originalUploaded = false; uploadOriginalBg();   // push THIS photo to R2 in the background
      setBackground('frosted'); // frosted-gray surround, matching the ornament
      initCrop();
      lowRes = imagePanelResolutionPx(1) < MIN_PANEL_PX;   // fresh upload = fit-to-frame
      if (lowRes) {
        document.getElementById('lw-lowres-modal').classList.add('on');
      } else {
        document.getElementById('lw-warn-editor').classList.remove('on');
        showEditor();
      }
      commitHistory();
    };
    img.src = e.target.result;
  };
  r.readAsDataURL(f);
}

function showEditor() {
  document.getElementById('lw-photo-controls').style.display = 'block';
  document.getElementById('lw-canvas-upload').style.display = 'none';
  document.getElementById('lw-pane-upload-btn').style.display = 'none';
  updateToolGating();
  // Reveal the photo toolbox (opens the tool sheet on mobile).
  document.dispatchEvent(new CustomEvent('lw-open-sheet', { detail: { tool: 'photo' } }));
}
// The background fill is chosen automatically (no picker): black behind a photo
// (any area the photo doesn't cover stays dark — the flattering nightlight look)
// and white for a text-only design (so dark text glows on a bright panel).
function setBackground(b) { bgChoice = b; }

function clearImage() {
  img = null; originalImg = null; rotation = 0; cropX = 0; cropY = 0; cropS = 1; lowRes = false;
  startedWithBg = false;
  document.getElementById('lw-warn-editor').classList.remove('on');
  document.getElementById('lw-warn-zoom').classList.remove('on');
  document.getElementById('lw-sl-z').value = 0;
  document.getElementById('lw-v-z').value = '1.00';
  document.getElementById('lw-file').value = '';
  document.getElementById('lw-photo-controls').style.display = 'none';
  document.getElementById('lw-pane-upload-btn').style.display = 'none';
  document.getElementById('lw-canvas-upload').style.display = '';
  // Photo is required before text/shapes, so return to the photo tool and
  // drop any text selection when the photo is removed.
  selectText(null);
  lwSwitchTool('photo');
  updateToolGating();
  draw();
  commitHistory();
}
document.getElementById('lw-clear').onclick = clearImage;
// Mobile reset buttons reuse the existing zoom/position reset logic.
document.getElementById('lw-m-reset-zoom').onclick = () => document.getElementById('lw-z-rst').click();
document.getElementById('lw-m-reset-pos').onclick = () => document.getElementById('lw-pos-rst').click();
document.getElementById('lw-m-change-photo').onclick = () => document.getElementById('lw-file').click();

// ±90° photo rotation
document.getElementById('lw-rot-l').onclick = () => rotateImage(-90);
document.getElementById('lw-rot-r').onclick = () => rotateImage(90);

document.getElementById('lw-pos-rst').onclick = () => {
  cropX = 0; cropY = 0;
  cropS = fitScale;
  document.getElementById('lw-sl-z').value = 0;
  document.getElementById('lw-v-z').value = '1.00';
  draw();
  commitHistory();
};

(function zoomSetup() {
  const sl = document.getElementById('lw-sl-z'), vi = document.getElementById('lw-v-z');
  function sliderToCropS(v) {
    const MAX_SCALE = fitScale * 3, MIN_SCALE = fitScale * 0.1;
    return v >= 0
      ? fitScale + (v / 100) * (MAX_SCALE - fitScale)
      : fitScale + (v / 100) * (fitScale - MIN_SCALE);
  }
  sl.oninput = () => {
    cropS = Math.max(0.01, sliderToCropS(+sl.value));
    vi.value = (cropS / fitScale).toFixed(2); checkZoomWarn(); draw();
  };
  sl.addEventListener('change', () => commitHistory());
  vi.onchange = () => {
    let n = parseFloat(vi.value); if (isNaN(n)) n = 1;
    n = Math.max(0.1, Math.min(3, n));
    cropS = n * fitScale;
    syncZoom(); checkZoomWarn(); draw();
    commitHistory();
  };
  vi.onkeydown = e => { if (e.key==='Enter') vi.dispatchEvent(new Event('change')); };
  document.getElementById('lw-z-up').onclick = () => {
    sl.value = Math.min(100, +sl.value + 1);
    cropS = Math.max(0.01, sliderToCropS(+sl.value));
    vi.value = (cropS / fitScale).toFixed(2); checkZoomWarn(); draw();
    commitHistory();
  };
  document.getElementById('lw-z-dn').onclick = () => {
    sl.value = Math.max(-100, +sl.value - 1);
    cropS = Math.max(0.01, sliderToCropS(+sl.value));
    vi.value = (cropS / fitScale).toFixed(2); checkZoomWarn(); draw();
    commitHistory();
  };
  document.getElementById('lw-z-rst').onclick = () => {
    if (!img) return;
    cropS = fitScale;
    sl.value = 0; vi.value = '1.00'; draw();
    commitHistory();
  };
})();

// ── Text overlay controls ──
// Curved text is only valid for single-line text — disable it per line when
// that line has a newline.
// Formatting gating is shared with the ornament via KobloText.applyGating; this
// adapts the nightlight's flat curved/align vars to the plain-layer interface.
function nlGating(layer) {
  if (layer === undefined) { nlGating(1); nlGating(2); return; }
  const sfx = layer === 1 ? '' : '2';
  const L = {
    txt: document.getElementById(layer === 1 ? 'lw-text-input' : 'lw-text-input2').value,
    curved: layer === 1 ? curvedEnabled : curvedEnabled2,
    align: layer === 1 ? textAlign1 : textAlign2
  };
  KobloText.applyGating(L, {
    curveRow: document.getElementById('lw-curve-toggle-row'+sfx),
    curveToggle: document.getElementById('lw-curve-toggle'+sfx),
    curveStepper: document.getElementById('lw-curve-stepper'+sfx),
    underlineBtn: document.getElementById('lw-style'+layer+'-underline'),
    alignBtns: { left: document.getElementById('lw-align'+layer+'-left'), center: document.getElementById('lw-align'+layer+'-center'), right: document.getElementById('lw-align'+layer+'-right') }
  });
  if (layer === 1) { curvedEnabled = L.curved; textAlign1 = L.align; }
  else { curvedEnabled2 = L.curved; textAlign2 = L.align; }
}
function updateCurveAvailability(layer) { nlGating(layer); }

// Shrinks a line's font size (never grows it back automatically) so it keeps
// fitting within the canvas width as the customer keeps typing — similar to
// PowerPoint's autofit.
function autoFitSize(text, bold, italic, font, currentSize) {
  const s = cv.width;   // shared logic in KobloText (identical: maxFrac 0.86 of width)
  return KobloText.autoFitSize(ctx, { text, bold, italic, font, size: currentSize,
    fontBasis: s, refWidth: s, maxFrac: 0.86, min: 5 });
}

document.getElementById('lw-text-input').oninput = () => {
  setCharNotice(document.getElementById('lw-count-1'), document.getElementById('lw-text-input').value.length);
  updateCurveAvailability();
  text1Size = autoFitSize(document.getElementById('lw-text-input').value, bold1, italic1, textFont1, text1Size);
  draw();
  scheduleHistoryCommit();
};
document.getElementById('lw-text-input2').oninput = () => {
  setCharNotice(document.getElementById('lw-count-2'), document.getElementById('lw-text-input2').value.length);
  text2Size = autoFitSize(document.getElementById('lw-text-input2').value, bold2, italic2, textFont2, text2Size);
  draw();
  scheduleHistoryCommit();
};

// Alignment buttons (independent per line)
['left','center','right'].forEach(a => {
  document.getElementById('lw-align1-'+a).onclick = function() {
    textAlign1 = a;
    ['left','center','right'].forEach(b => {
      const btn = document.getElementById('lw-align1-'+b);
      btn.className = 'lw-color-opt' + (b === a ? ' active-dark' : '');
    });
    draw();
    commitHistory();
  };
  document.getElementById('lw-align2-'+a).onclick = function() {
    textAlign2 = a;
    ['left','center','right'].forEach(b => {
      const btn = document.getElementById('lw-align2-'+b);
      btn.className = 'lw-color-opt' + (b === a ? ' active-dark' : '');
    });
    draw();
    commitHistory();
  };
});

// Font dropdowns (per line)
document.getElementById('lw-font-select-1').onchange = function() {
  textFont1 = this.value;
  text1Size = autoFitSize(document.getElementById('lw-text-input').value, bold1, italic1, textFont1, text1Size);
  draw();
  document.fonts.ready.then(draw);
  commitHistory();
};
document.getElementById('lw-font-select-2').onchange = function() {
  textFont2 = this.value;
  text2Size = autoFitSize(document.getElementById('lw-text-input2').value, bold2, italic2, textFont2, text2Size);
  draw();
  document.fonts.ready.then(draw);
  commitHistory();
};

// Text style toggles (per line — Bold / Italic / Underline, independent on/off)
function syncStyleButtons() {
  document.getElementById('lw-style1-bold').classList.toggle('active', bold1);
  document.getElementById('lw-style1-italic').classList.toggle('active', italic1);
  document.getElementById('lw-style1-underline').classList.toggle('active', underline1);
  document.getElementById('lw-style2-bold').classList.toggle('active', bold2);
  document.getElementById('lw-style2-italic').classList.toggle('active', italic2);
  document.getElementById('lw-style2-underline').classList.toggle('active', underline2);
}
function bindStyleToggle(id, get, set, layer) {
  document.getElementById(id).onclick = function() {
    set(!get());
    syncStyleButtons();
    if (layer === 1) text1Size = autoFitSize(document.getElementById('lw-text-input').value, bold1, italic1, textFont1, text1Size);
    else text2Size = autoFitSize(document.getElementById('lw-text-input2').value, bold2, italic2, textFont2, text2Size);
    draw();
    document.fonts.ready.then(draw);
    commitHistory();
  };
}
bindStyleToggle('lw-style1-bold',      () => bold1,      v => bold1 = v,      1);
bindStyleToggle('lw-style1-italic',    () => italic1,    v => italic1 = v,    1);
bindStyleToggle('lw-style1-underline', () => underline1, v => underline1 = v, 1);
bindStyleToggle('lw-style2-bold',      () => bold2,      v => bold2 = v,      2);
bindStyleToggle('lw-style2-italic',    () => italic2,    v => italic2 = v,    2);
bindStyleToggle('lw-style2-underline', () => underline2, v => underline2 = v, 2);

// Font-size stepper (mobile). Desktop resizes via the canvas corner handles.
function updateSizeVals() {
  const v1 = document.getElementById('lw-size1-val'); if (v1) v1.textContent = Math.round(text1Size);
  const v2 = document.getElementById('lw-size2-val'); if (v2) v2.textContent = Math.round(text2Size);
}
function stepSize(layer, delta) {
  if (layer === 1) text1Size = Math.max(5, Math.min(60, text1Size + delta));
  else text2Size = Math.max(5, Math.min(60, text2Size + delta));
  draw();
  commitHistory();
}
document.getElementById('lw-size1-dn').onclick = () => stepSize(1, -1);
document.getElementById('lw-size1-up').onclick = () => stepSize(1, 1);
document.getElementById('lw-size2-dn').onclick = () => stepSize(2, -1);
document.getElementById('lw-size2-up').onclick = () => stepSize(2, 1);
document.getElementById('lw-text-del-1').onclick = () => deleteTextLayer('text1');
document.getElementById('lw-text-del-2').onclick = () => deleteTextLayer('text2');

// Curved text: per line — a toggle plus a ± stepper (±10) beside it.
function bindCurve(layer) {
  const sfx = layer === 1 ? '' : '2';
  const toggle  = document.getElementById('lw-curve-toggle'+sfx);
  const stepper = document.getElementById('lw-curve-stepper'+sfx);
  const valEl   = document.getElementById('lw-curve-value'+sfx);
  const getAmt = () => layer === 1 ? curveAmount : curveAmount2;
  const setAmt = v => { if (layer === 1) curveAmount = v; else curveAmount2 = v; };
  toggle.onchange = function() {
    if (layer === 1) curvedEnabled = this.checked; else curvedEnabled2 = this.checked;
    stepper.style.display = this.checked ? 'inline-flex' : 'none';
    // Curved and underline can't combine — turning curve on clears underline
    // (not just graying the button) so its active state doesn't linger.
    if (this.checked) {
      if (layer === 1) underline1 = false; else underline2 = false;
      syncStyleButtons();
    }
    updateUnderlineAvailability(layer);
    updateAlignAvailability(layer);
    draw();
    commitHistory();
  };
  document.getElementById('lw-curve-dn'+sfx).onclick = () => { setAmt(Math.max(10, getAmt() - 10)); valEl.textContent = getAmt(); draw(); commitHistory(); };
  document.getElementById('lw-curve-up'+sfx).onclick = () => { setAmt(Math.min(100, getAmt() + 10)); valEl.textContent = getAmt(); draw(); commitHistory(); };
  const flipBtn = document.getElementById('lw-curve-flip'+sfx);
  if (flipBtn) flipBtn.onclick = () => { if (layer === 1) curveFlip = !curveFlip; else curveFlip2 = !curveFlip2; draw(); commitHistory(); };
}
bindCurve(1);
bindCurve(2);
// Underline-availability + align-availability are both handled by the shared
// gating (KobloText.applyGating via nlGating); kept as thin aliases so all the
// existing call sites still work.
function updateUnderlineAvailability(layer) { nlGating(layer); }
function updateAlignAvailability(layer) { nlGating(layer); }
function syncCurveUI() {
  [['', curvedEnabled, curveAmount], ['2', curvedEnabled2, curveAmount2]].forEach(([sfx, en, amt]) => {
    document.getElementById('lw-curve-toggle'+sfx).checked = en;
    document.getElementById('lw-curve-stepper'+sfx).style.display = en ? 'inline-flex' : 'none';
    document.getElementById('lw-curve-value'+sfx).textContent = amt;
  });
  updateUnderlineAvailability();
  updateAlignAvailability();
}

// Text color swatches (black / white, per line)
function setTextColor(layer, c) {
  if (layer === 1) textColor1 = c; else textColor2 = c;
  document.getElementById('lw-text'+layer+'-dark').classList.toggle('active-sw', c === 'dark');
  document.getElementById('lw-text'+layer+'-light').classList.toggle('active-sw', c === 'light');
  draw();
  commitHistory();
}
document.getElementById('lw-text1-dark').onclick = () => setTextColor(1, 'dark');
document.getElementById('lw-text1-light').onclick = () => setTextColor(1, 'light');
document.getElementById('lw-text2-dark').onclick = () => setTextColor(2, 'dark');
document.getElementById('lw-text2-light').onclick = () => setTextColor(2, 'light');

// Outline toggle (auto-contrasting: white outline on dark text, black on light)
document.getElementById('lw-outline1-toggle').onchange = function() {
  outline1 = this.checked;
  draw();
  commitHistory();
};
document.getElementById('lw-outline2-toggle').onchange = function() {
  outline2 = this.checked;
  draw();
  commitHistory();
};

// Add-shape buttons
document.getElementById('lw-add-rect').onclick = () => addShape('rect');
document.getElementById('lw-add-circle').onclick = () => addShape('circle');
document.getElementById('lw-add-triangle').onclick = () => addShape('triangle');

// Shape color toggle (applies to the currently selected shape)
document.getElementById('lw-shape-dark').onclick = () => {
  if (!selectedShapeId) return;
  const shape = getShape(selectedShapeId);
  if (shape) shape.color = 'dark';
  syncShapeColorButtons();
  draw();
  commitHistory();
};
document.getElementById('lw-shape-light').onclick = () => {
  if (!selectedShapeId) return;
  const shape = getShape(selectedShapeId);
  if (shape) shape.color = 'light';
  syncShapeColorButtons();
  draw();
  commitHistory();
};

document.getElementById('lw-clear-shapes').onclick = () => {
  shapes = [];
  selectedShapeId = null;
  draw();
  commitHistory();
};

// ── Restart Design — resets everything back to the blank starting state ──
function getBlankSnapshot() {
  return {
    imgSrc: null,
    rotation: 0,
    cropX: 0, cropY: 0, cropS: 1, fitScale: 1,
    bgChoice: 'white',
    text1: '', text2: '',
    textColor1: 'dark', textAlign1: 'center', textColor2: 'dark', textAlign2: 'center',
    textFont1: 'Playfair Display', textFont2: 'Playfair Display',
    bold1: false, italic1: false, underline1: false,
    bold2: false, italic2: false, underline2: false,
    outline1: false, outline2: false,
    curvedEnabled: false, curveAmount: 50, curveFlip: false, curvedEnabled2: false, curveAmount2: 50, curveFlip2: false,
    text1X: 0.5, text1Y: 0.72, text1Size: 22, text1BoxW: 0,
    text2X: 0.5, text2Y: 0.88, text2Size: 16, text2BoxW: 0,
    shapes: [], nextShapeId: 1,
  };
}
document.getElementById('lw-restart-design').onclick = () => {
  KOBLO.confirm({
    title: T('restartTitle', 'Restart your design?'),
    body: T('restartBodyNightlight', 'This clears your photo, text, and shapes.'),
    confirmText: T('restartConfirm', 'Restart'), cancelText: T('restartCancel', 'Keep editing'), danger: true
  }).then((ok) => {
    if (!ok) return;
    selectedText = null;
    selectedShapeId = null;
    const dnEl = document.getElementById('lw-design-name'); if (dnEl) dnEl.value = '';
    applySnapshot(getBlankSnapshot());
    commitHistory();
  });
};

// The print image is rendered at a FIXED resolution regardless of the on-screen
// canvas size, so a phone (cv ~700px) and a desktop (cv ~1100px) produce the
// identical file. We re-composite the scene (photo + baked text + shapes) at
// PRINT_PX instead of upscaling the small display canvas — same primitives and
// texScale mapping the 3D preview uses (renderPanel3D), so it's pixel-faithful.
const PRINT_PX = 1080;
function getBlob() {
  const texScale = PRINT_PX / cv.width;
  const scene = document.createElement('canvas'); scene.width = scene.height = PRINT_PX;
  const sx = scene.getContext('2d');
  drawBase(sx, scene, {cropX: cropX*texScale, cropY: cropY*texScale, cropS: cropS*texScale});
  drawShapesLayer(sx, PRINT_PX);
  drawTextOverlay(sx, scene);
  // Trim the physical cut edge (same crop the old display-canvas export did).
  const bw = PRINT_PX*LITHO_CROP_FRAC, inner = PRINT_PX-bw*2;
  const oc = document.createElement('canvas'); oc.width = oc.height = PRINT_PX;
  const ox = oc.getContext('2d');
  ox.fillStyle = '#fff'; ox.fillRect(0,0,PRINT_PX,PRINT_PX);
  ox.drawImage(scene, bw, bw, inner, inner, 0, 0, PRINT_PX, PRINT_PX);
  return new Promise(r => oc.toBlob(r, 'image/jpeg', 0.92));
}

function getOriginalBlob() {
  if (!img) return null;
  // The stored original (text-free) is the high-res source of truth: it's what
  // re-editing reopens and what a future finer-resolution generator would print
  // from. Cap the long edge at 2048 — high detail without turning a 12MP phone
  // photo into a multi-MB file. This is uploaded in the BACKGROUND at photo-load
  // time (uploadOriginalBg), so its size no longer sits on the add-to-cart click.
  const MAX = 2048;
  const scale = Math.min(1, MAX / Math.max(img.width, img.height));
  const w = Math.max(1, Math.round(img.width * scale));
  const h = Math.max(1, Math.round(img.height * scale));
  const oc = document.createElement('canvas');
  oc.width = w;
  oc.height = h;
  oc.getContext('2d').drawImage(img, 0, 0, w, h);
  return new Promise(r => oc.toBlob(r, 'image/jpeg', 0.9));
}

// ── Edit-mode rehydration ──
async function rehydrateEdit() {
  if (!editJobId) return;
  try {
    const res = await fetch(`${API_BASE}/job/${editJobId}/data`);
    if (!res.ok) {
      document.getElementById('lw-shell-loading').style.display = 'none';
      return;
    }
    const data = await res.json();
    const meta = data.meta;

    bgChoice = meta.bgChoice || 'white';

    const dnEl = document.getElementById('lw-design-name');
    if (dnEl) dnEl.value = meta.design_name || '';
    document.getElementById('lw-text-input').value = meta.text1 || '';
    document.getElementById('lw-text-input2').value = meta.text2 || '';
    setCharNotice(document.getElementById('lw-count-1'), (meta.text1 || '').length);
    setCharNotice(document.getElementById('lw-count-2'), (meta.text2 || '').length);
    textColor1 = meta.textColor1 || meta.textColor || 'dark';
    textAlign1 = meta.textAlign1 || meta.textAlign || 'center';
    textColor2 = meta.textColor2 || meta.textColor || 'dark';
    textAlign2 = meta.textAlign2 || meta.textAlign || 'center';
    textFont1 = meta.font || 'Playfair Display';
    textFont2 = meta.font2 || 'Playfair Display';
    // New independent flags, with fallback to the old single 'textStyle' string
    bold1 = meta.bold1 != null ? !!meta.bold1 : meta.textStyle1 === 'bold';
    italic1 = meta.italic1 != null ? !!meta.italic1 : meta.textStyle1 === 'italic';
    underline1 = !!meta.underline1;
    bold2 = meta.bold2 != null ? !!meta.bold2 : meta.textStyle2 === 'bold';
    italic2 = meta.italic2 != null ? !!meta.italic2 : meta.textStyle2 === 'italic';
    underline2 = !!meta.underline2;
    outline1 = !!meta.outline1;
    outline2 = !!meta.outline2;
    document.getElementById('lw-outline1-toggle').checked = outline1;
    document.getElementById('lw-outline2-toggle').checked = outline2;
    curvedEnabled = !!meta.curved;
    curveAmount = meta.curveAmount != null ? meta.curveAmount : 50;
    curveFlip = !!meta.curveFlip;
    curvedEnabled2 = !!meta.curved2;
    curveAmount2 = meta.curveAmount2 != null ? meta.curveAmount2 : 50;
    curveFlip2 = !!meta.curveFlip2;
    text1X = meta.text1X != null ? meta.text1X : 0.5;
    text1Y = meta.text1Y != null ? meta.text1Y : 0.72;
    text1Size = meta.text1Size || 22;
    text1BoxW = meta.text1BoxW != null ? meta.text1BoxW : 0;
    text2X = meta.text2X != null ? meta.text2X : 0.5;
    text2Y = meta.text2Y != null ? meta.text2Y : 0.88;
    text2Size = meta.text2Size || 16;
    text2BoxW = meta.text2BoxW != null ? meta.text2BoxW : 0;

    document.getElementById('lw-font-select-1').value = textFont1;
    document.getElementById('lw-font-select-2').value = textFont2;
    syncStyleButtons();
    syncCurveUI();
    updateCurveAvailability();
    if (textColor1 === 'light') document.getElementById('lw-text1-light').click();
    document.getElementById('lw-align1-' + textAlign1).click();
    if (textColor2 === 'light') document.getElementById('lw-text2-light').click();
    document.getElementById('lw-align2-' + textAlign2).click();

    if (data.image_base64) {
      img = new Image();
      img.onload = () => {
        originalImg = img; rotation = 0;   // saved image already carries its orientation
        initCrop({ cropS: meta.cropS, cropX: meta.cropX, cropY: meta.cropY });
        lowRes = imagePanelResolutionPx(meta.cropS || 1) < MIN_PANEL_PX;   // account for saved zoom
        showEditor();
        draw();
        // Start the edit with ONE clean history entry (the loaded design), so Undo
        // stays disabled until the shopper makes a real change. The setup clicks
        // above (fonts/colors/alignment) otherwise leave intermediate states, and
        // Undo would jump back to a photo-less state — wiping the loaded image.
        requestAnimationFrame(() => {
          clearTimeout(historyDebounceTimer);
          historyStack = [snapshotState()];
          historyIndex = 0;
          updateHistoryButtons();
        });
        document.getElementById('lw-shell-loading').style.display = 'none';
        editHydrated = true;                       // changes from here on count as dirty
      };
      img.src = data.image_base64;
    } else {
      sizeCanvas();
      draw();
      commitHistory();
      document.getElementById('lw-shell-loading').style.display = 'none';
      editHydrated = true;                         // changes from here on count as dirty
    }
  } catch (e) {
    console.error('Failed to rehydrate edit job', e);
    document.getElementById('lw-shell-loading').style.display = 'none';
  }
}

// Size the canvas immediately so background + text render even before any
// photo is uploaded (photo is now optional).
requestAnimationFrame(() => { sizeCanvas(); draw(); document.fonts.ready.then(draw); if (!editJobId) commitHistory(); });

rehydrateEdit();

// ── Keep the canvas correctly sized on window resize, preserving the
// photo's relative crop/zoom (text positions are already stored as ratios
// so they need no adjustment) ──
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    if (mode === 'design') {
      if (img) {
        initCrop({ cropS: cropS/fitScale, cropX: cropX/cv.width, cropY: cropY/cv.width });
      } else {
        sizeCanvas(); draw();
      }
    } else {
      buildComposite();
    }
  }, 150);
});

// Mobile browsers purge canvas bitmaps / GPU contexts when a tab is backgrounded
// for a while (e.g. the phone is locked). On return, the preview can come back
// blank or stuck on "Building preview…". Rebuild it when the page becomes
// visible again (small delay so the GPU is back before we re-render).
function rebuildPreviewIfVisible() {
  if (document.hidden) return;
  if (mode === 'preview' && PLATE && shell.classList.contains('open')) {
    setTimeout(() => { if (!document.hidden && mode === 'preview') buildComposite(); }, 250);
  }
}
document.addEventListener('visibilitychange', rebuildPreviewIfVisible);
window.addEventListener('pageshow', rebuildPreviewIfVisible);

// ── 3D Preview ──
// ── Photoreal preview: composite the lit design onto a real product photo ──
// The wall, warm glow spill and plug all come from the real photograph; we only
// swap the user's design onto the lit panel. Locked — no rotation/movement.
let _plateImg = null;
function loadPlate() {
  return new Promise((res, rej) => {
    if (_plateImg && _plateImg.complete) return res(_plateImg);
    const im = new Image();
    // The plate is served from Shopify's CDN (cross-origin to the storefront),
    // so request it with CORS — otherwise drawing it taints the canvas and the
    // Add-to-Cart preview export (toDataURL) throws a SecurityError.
    im.crossOrigin = 'anonymous';
    im.onload = () => { _plateImg = im; res(im); };
    im.onerror = rej;
    im.src = PLATE.url;
  });
}
// Render the exact dialed-in 3D panel to an OFFSCREEN, transparent canvas at a
// fixed head-on camera, and
// report where the panel landed (projected bounding box) so it can be dropped
// onto the photo at the right spot.
function renderPanel3D(SZ) {
  const ARC=(GEO.arcDeg ?? 75)*Math.PI/180, BD=GEO.borderDepth ?? 4, R=(GEO.chordMM ?? 105.31)/(2*Math.sin(ARC/2))-BD;
  const H=LITHO_H, MN=GEO.minDepth ?? 0.84, MX=GEO.maxDepth ?? 2.94, BT=LITHO_BT, CH=LITHO_CH, res=400;
  const hiRes=900;
  const hiCanvas=document.createElement('canvas'); hiCanvas.width=hiCanvas.height=hiRes;
  const hiCtx=hiCanvas.getContext('2d');
  const texScale=hiRes/cv.width;
  drawBase(hiCtx, hiCanvas, {cropX:cropX*texScale, cropY:cropY*texScale, cropS:cropS*texScale});
  drawShapesLayer(hiCtx, hiRes);
  drawTextOverlay(hiCtx, hiCanvas);
  const tmp=document.createElement('canvas'); tmp.width=tmp.height=res;
  const tx=tmp.getContext('2d',{willReadFrequently:true});
  tx.fillStyle='#fff'; tx.fillRect(0,0,res,res);
  const bw=hiRes*LITHO_CROP_FRAC, inn=hiRes-bw*2;
  tx.drawImage(hiCanvas,bw,bw,inn,inn,0,0,res,res);
  const pix=tx.getImageData(0,0,res,res).data;
  const dep=(r,c)=>{ const g=pix[((res-1-r)*res+(res-1-c))*4]; return MN+(1-g/255)*(MX-MN); };
  const ah=ARC/2;
  const aA=Array.from({length:res},(_,i)=>-ah+i*2*ah/(res-1));
  const zA=Array.from({length:res},(_,i)=>i*H/(res-1));
  const iP=[],iI=[],depths=[];
  for (let r=0;r<res;r++) for (let c=0;c<res;c++){
    const a=aA[c],z=zA[r];
    const dL=(a+ah)*R,dR=(ah-a)*R,dB=z,dT=H-z;
    const inBorder=dL<BT||dR<BT||dB<BT||dT<BT;
    const inChamfer=!inBorder&&(dL<BT+CH||dR<BT+CH||dB<BT+CH||dT<BT+CH);
    let d;
    if(inBorder){d=BD;}
    else if(inChamfer){
      let t=0;
      if(dL<BT+CH&&dL>=BT) t=Math.max(t,1-(dL-BT)/CH);
      if(dR<BT+CH&&dR>=BT) t=Math.max(t,1-(dR-BT)/CH);
      if(dB<BT+CH&&dB>=BT) t=Math.max(t,1-(dB-BT)/CH);
      if(dT<BT+CH&&dT>=BT) t=Math.max(t,1-(dT-BT)/CH);
      d=Math.max(MN+t*(BD-MN), dep(r,c));
    } else {d=dep(r,c);}
    depths.push(d);
    const fr=R+d;
    iP.push(fr*Math.sin(a),fr*Math.cos(a),z);
  }
  for (let r=0;r<res-1;r++) for (let c=0;c<res-1;c++){const b=r*res+c;iI.push(b,b+1,b+res+1,b,b+res+1,b+res);}

  const glc=document.createElement('canvas'); glc.width=glc.height=SZ;
  const ren=new THREE.WebGLRenderer({canvas:glc,antialias:true,alpha:true,preserveDrawingBuffer:true});
  ren.setSize(SZ,SZ,false); ren.setPixelRatio(1); ren.setClearColor(0x000000,0);
  const scene=new THREE.Scene();
  const cam=new THREE.PerspectiveCamera(38,1,0.1,2000);
  const mat=new THREE.MeshStandardMaterial({vertexColors:true,roughness:0.72,metalness:0,side:THREE.DoubleSide});
  // Transmission colour, dialled in against the real printed part: THIN = thinnest
  // wall, THICK = the darkest. Raw exp() never REACHES the floor though — at the
  // old ABSORB 0.7 the thickest wall landed on 123, not 84, so the bottom third of
  // the tuned range went unused and thick (dark) areas had almost no separation:
  // a black line on a dark fill rendered 1.20x apart against a true 1.64x.
  // Normalising T to hit 0 at the thickest wall reclaims that range without moving
  // either endpoint, and the lower ABSORB straightens the curve so midtones don't
  // sag in exchange.
  const THIN=[255,240,212], THICK=[84,60,40], ABSORB=0.35;
  // Clamped because the raised frame is BD (4 mm) thick — past MX — so without the
  // clamp it normalises negative and the frame renders black instead of landing on
  // THICK. depths[] spans MN..BD, but the tonal range is defined by the photo's
  // MN..MX; anything beyond simply sits at the floor.
  // Full normalisation: T reaches 0 at the thickest photo wall, so the darkest
  // tone lands exactly on THICK (84) instead of stopping at 123 the way the raw
  // exp() did. Highlights stay within 1/255 of the original tuning and midtones
  // within 5%; the dark end separates at 1.53x instead of 1.20x. Chosen against
  // the printed part over a gentler partial pull.
  const T_FLOOR=Math.exp(-ABSORB*(MX-MN));
  const iColors=[];
  for (let n=0;n<depths.length;n++){
    const T=Math.max(0,Math.min(1,(Math.exp(-ABSORB*(depths[n]-MN))-T_FLOOR)/(1-T_FLOOR)));
    iColors.push((THICK[0]+(THIN[0]-THICK[0])*T)/255,(THICK[1]+(THIN[1]-THICK[1])*T)/255,(THICK[2]+(THIN[2]-THICK[2])*T)/255);
  }
  const gI=new THREE.BufferGeometry();
  gI.setAttribute('position', new THREE.Float32BufferAttribute(iP,3));
  gI.setAttribute('color', new THREE.Float32BufferAttribute(iColors,3));
  gI.setIndex(iI); gI.computeVertexNormals();
  scene.add(new THREE.Mesh(gI,mat));
  gI.computeBoundingBox(); const bb=gI.boundingBox;
  const mcx=(bb.max.x+bb.min.x)/2,mcy=(bb.max.y+bb.min.y)/2,mcz=(bb.max.z+bb.min.z)/2;
  scene.children.forEach(m=>{if(m.isMesh)m.position.set(-mcx,-mcy,-mcz);});
  const dist=Math.max(bb.max.z-bb.min.z,bb.max.x-bb.min.x)/(2*Math.tan(38*Math.PI/360))*1.55;
  cam.position.set(0,dist,0); cam.up.set(0,0,1); cam.lookAt(0,0,0);   // straight-on (no elevation) so the top/bottom bow is symmetric
  scene.add(new THREE.AmbientLight(0xfff4e6,0.82));
  const kl=new THREE.DirectionalLight(0xffe6c8,0.28); kl.position.set(0,1,2.2); scene.add(kl);   // centred — no left/right shading bias
  cam.updateMatrixWorld(); ren.render(scene,cam);

  // Copy to a stable 2D canvas (so we can dispose the GL context) and find the
  // EXACT panel silhouette = tight bounds of the non-transparent pixels.
  const out2d=document.createElement('canvas'); out2d.width=out2d.height=SZ;
  const octx=out2d.getContext('2d'); octx.drawImage(glc,0,0);
  // Free the GL context immediately — repeated rebuilds (e.g. browser zoom firing
  // resize) would otherwise pile up contexts and hit the browser's live limit.
  try { ren.forceContextLoss(); } catch(e){}
  ren.dispose();
  const a=octx.getImageData(0,0,SZ,SZ).data;
  let minx=SZ,miny=SZ,maxx=0,maxy=0;
  for(let y=0;y<SZ;y++){ const row=y*SZ; for(let x=0;x<SZ;x++){ if(a[(row+x)*4+3]>40){ if(x<minx)minx=x; if(x>maxx)maxx=x; if(y<miny)miny=y; if(y>maxy)maxy=y; } } }
  return {canvas:out2d, rect:{x:minx,y:miny,w:maxx-minx+1,h:maxy-miny+1}};
}

async function buildComposite() {
  document.getElementById('lw-prev-load').style.display = 'flex';
  document.getElementById('lw-cart-btn').disabled = true;
  previewReady = false;

  try {
  // The real product photo (wall / warm glow / plug are all real).
  const im = await loadPlate();

  // The dialed-in 3D render, on a transparent background.
  const SZ = 1100;
  const { canvas: panel, rect } = renderPanel3D(SZ);

  // Size the preview canvas to the pane; cover-fit the photo.
  const wrap = document.getElementById('lw-prev-wrap');
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const W = Math.max(1, Math.round(wrap.clientWidth * dpr));
  const Hpx = Math.max(1, Math.round(wrap.clientHeight * dpr));
  const cvp = document.getElementById('lw-3d-cv');
  cvp.width = W; cvp.height = Hpx;
  cvp.style.cursor = 'default'; cvp.onmousedown = null;   // locked — no orbit
  if (window.__resetPreviewZoom) window.__resetPreviewZoom();   // start each preview at 1×
  const ctx = cvp.getContext('2d');
  ctx.clearRect(0, 0, W, Hpx);
  const iw = im.naturalWidth, ih = im.naturalHeight;
  // Cover-fit everywhere: fill the pane, letting the excess extend off-screen (no
  // letterbox, no gaps to fill). The plate is already zoomed out with lots of
  // wall around the nightlight, so this barely crops and never cuts the light —
  // and it avoids the streaky edge-stretch the desktop side-gaps used to need.
  const sc = Math.max(W / iw, Hpx / ih);
  const dw = iw * sc, dh = ih * sc, ox = (W - dw) / 2, oy = (Hpx - dh) / 2;
  ctx.drawImage(im, ox, oy, dw, dh);

  // Drop the 3D render onto the photo where the panel sits (resting on the plug).
  const pr = PLATE.panelRect;   // [x, y, w, h]  — fractions of the plate image
  const dx = ox + pr[0] * dw, dy = oy + pr[1] * dh, dW = pr[2] * dw, dH = pr[3] * dh;
  const sx = rect.x, sy = rect.y, sW = rect.w, sH = rect.h;
  // Remember where the nightlight sits so the cart thumbnail can be a 1:1 square
  // centred on it (a little wall/frame around it), not the wide composite.
  previewPanelBox = { cx: dx + dW / 2, cy: dy + dH / 2, s: Math.max(dW, dH) * 1.78 };

  // Soft bloom so the panel's light melds into the photo's glow (not pasted-on).
  ctx.save();
  ctx.globalCompositeOperation = 'screen'; ctx.globalAlpha = 0.22;
  ctx.filter = 'blur(' + Math.max(2, Math.round(dW * 0.02)) + 'px)';
  ctx.drawImage(panel, sx, sy, sW, sH, dx, dy, dW, dH);
  ctx.restore();
  // The panel itself.
  ctx.drawImage(panel, sx, sy, sW, sH, dx, dy, dW, dH);

  previewReady = true;
  updateCartBtnState();
  } catch (e) {
    // Never leave the "Building preview…" overlay stuck on a failure.
    console.error('Preview build failed', e);
  } finally {
    document.getElementById('lw-prev-load').style.display = 'none';
  }
}

// Cart thumbnail: a 1:1 SQUARE centred on the nightlight (not the wide composite).
// Bake in the 3D-fallback bloom if present (composite mode has none).
function previewDataURL(){
  const c3=document.getElementById('lw-3d-cv'); if(!c3||!c3.width) return null;
  const full=document.createElement('canvas'); full.width=c3.width; full.height=c3.height;
  const fx=full.getContext('2d'); fx.drawImage(c3,0,0);
  const bc=document.getElementById('lw-3d-bloom');
  if(bc){ fx.globalCompositeOperation='screen'; fx.drawImage(bc,0,0); }
  // square crop centred on the panel (fallback: canvas centre)
  let cx=c3.width/2, cy=c3.height/2, s=Math.min(c3.width,c3.height);
  if(previewPanelBox){ cx=previewPanelBox.cx; cy=previewPanelBox.cy; s=previewPanelBox.s; }
  s=Math.min(s, c3.width, c3.height);
  const sx=Math.max(0,Math.min(c3.width -s, cx-s/2));
  const sy=Math.max(0,Math.min(c3.height-s, cy-s/2));
  const out=document.createElement('canvas'); out.width=out.height=Math.min(700,Math.round(s));
  out.getContext('2d').drawImage(full, sx, sy, s, s, 0, 0, out.width, out.height);
  return out.toDataURL('image/jpeg',0.85);
}

// ── Composite preview: pinch (mobile) / scroll (desktop) to zoom in up to 1.2×,
// drag to pan when zoomed. Applied as a CSS transform on the preview canvas; the
// wrap's overflow:hidden clips it. Locked otherwise (no rotation). ──
(function previewZoom(){
  const cv2 = document.getElementById('lw-3d-cv');
  const wrap = document.getElementById('lw-prev-wrap');
  if (!cv2 || !wrap || !PLATE) return;
  const MAX = 1.3;
  let z = 1, px = 0, py = 0, dragging = false, lastX = 0, lastY = 0, pinch = 0;
  const activePreview = () => mode === 'preview';
  function apply(){
    // Keep the scaled canvas covering the wrap (can't pan past its edges).
    const mx = (z - 1) * wrap.clientWidth / 2, my = (z - 1) * wrap.clientHeight / 2;
    px = Math.max(-mx, Math.min(mx, px));
    py = Math.max(-my, Math.min(my, py));
    cv2.style.transformOrigin = 'center center';
    cv2.style.transform = z > 1.001 ? `translate(${px}px,${py}px) scale(${z})` : '';
    cv2.style.cursor = z > 1.001 ? (dragging ? 'grabbing' : 'grab') : 'default';
  }
  window.__resetPreviewZoom = () => { z = 1; px = 0; py = 0; dragging = false; pinch = 0; cv2.style.transform = ''; cv2.style.cursor = 'default'; };
  const zoomBy = f => { z = Math.max(1, Math.min(MAX, z * f)); apply(); };

  cv2.addEventListener('wheel', e => { if (!activePreview()) return; e.preventDefault(); zoomBy(e.deltaY < 0 ? 1.08 : 0.92); }, { passive: false });
  cv2.addEventListener('mousedown', e => { if (!activePreview() || z <= 1.001) return; dragging = true; lastX = e.clientX; lastY = e.clientY; apply(); });
  window.addEventListener('mousemove', e => { if (!dragging) return; px += e.clientX - lastX; py += e.clientY - lastY; lastX = e.clientX; lastY = e.clientY; apply(); });
  window.addEventListener('mouseup', () => { if (dragging) { dragging = false; apply(); } });
  cv2.addEventListener('touchstart', e => {
    if (!activePreview()) return;
    if (e.touches.length === 2) pinch = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
    else if (e.touches.length === 1 && z > 1.001) { dragging = true; lastX = e.touches[0].clientX; lastY = e.touches[0].clientY; }
  }, { passive: true });
  cv2.addEventListener('touchmove', e => {
    if (!activePreview()) return;
    if (e.touches.length === 2) { e.preventDefault(); const d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY); if (pinch) zoomBy(d / pinch); pinch = d; }
    else if (e.touches.length === 1 && dragging) { e.preventDefault(); px += e.touches[0].clientX - lastX; py += e.touches[0].clientY - lastY; lastX = e.touches[0].clientX; lastY = e.touches[0].clientY; apply(); }
  }, { passive: false });
  cv2.addEventListener('touchend', () => { dragging = false; pinch = 0; });
})();

// ── Add to Cart ──
document.getElementById('lw-confirm-proceed').onclick = async () => {
  if (!document.getElementById('lw-confirm-design').checked) {   // require approval, with a message
    if (window.KOBLO && KOBLO.toast) KOBLO.toast(T('approveRequired', 'Please check the box to confirm you approve your design.'));
    return;
  }
  const btn=document.getElementById('lw-cart-btn'), st=document.getElementById('lw-status');
  const loadMsg=document.getElementById('lw-confirm-loading-msg');
  const setLoad=(t)=>{ loadMsg.textContent=t; st.textContent=t; };
  // Show the loading state INSIDE the confirm dialog (not the discreet corner status),
  // so shoppers clearly see it's working and don't refresh.
  document.getElementById('lw-confirm-form').style.display='none';
  document.getElementById('lw-confirm-spinner').style.display='';
  document.getElementById('lw-confirm-retry').style.display='none';
  document.getElementById('lw-confirm-loading-sub').textContent=T('pleaseWait','Please don’t close or refresh this page.');
  document.getElementById('lw-confirm-loading').style.display='block';
  btn.disabled=true; setLoad(T('saving','Saving your design…')); st.className='lw-header-status';
  try {
    const blob=await getBlob();
    // If the full-res original was already pushed in the background for THIS
    // reserved job at the current rotation, skip re-sending it (the big file
    // stays off the click). Otherwise fall back to sending it inline.
    const skipOriginal = !editJobId && reservedJobId && reservedVariantId
                         && originalUploaded && originalUploadedRotation === rotation;
    const originalBlob = skipOriginal ? null : await getOriginalBlob();

    const previewB64=previewDataURL();

    const fd=new FormData();
    fd.append('image', blob, 'litho.jpg');
    if (originalBlob) fd.append('clean_image', originalBlob, 'original.jpg');
    else if (skipOriginal) fd.append('clean_pre_uploaded', originalUploadExt);
    fd.append('resolution', '0.10');
    if(previewB64) fd.append('preview', previewB64);
    const t1=document.getElementById('lw-text-input');
    const t2=document.getElementById('lw-text-input2');
    if(t1) fd.append('text1', t1.value||'');
    if(t2) fd.append('text2', t2.value||'');
    fd.append('font', textFont1);
    fd.append('font2', textFont2);
    // Legacy single-style field kept for backend compatibility, plus the new
    // independent Bold/Italic/Underline flags.
    fd.append('textStyle1', bold1 ? 'bold' : italic1 ? 'italic' : 'regular');
    fd.append('textStyle2', bold2 ? 'bold' : italic2 ? 'italic' : 'regular');
    fd.append('bold1', bold1); fd.append('italic1', italic1); fd.append('underline1', underline1);
    fd.append('bold2', bold2); fd.append('italic2', italic2); fd.append('underline2', underline2);
    fd.append('outline1', outline1);
    fd.append('outline2', outline2);
    fd.append('curved', curvedEnabled);
    fd.append('curveAmount', curveAmount);
    fd.append('curveFlip', curveFlip);
    fd.append('curved2', curvedEnabled2);
    fd.append('curveAmount2', curveAmount2);
    fd.append('curveFlip2', curveFlip2);
    fd.append('alignment', textAlign1);
    fd.append('bgChoice', bgChoice);
    fd.append('cropX', img ? cropX / cv.width : 0);
    fd.append('cropY', img ? cropY / cv.width : 0);
    fd.append('cropS', img ? cropS / fitScale : 0);
    fd.append('textColor', textColor1);
    fd.append('textAlign', textAlign1);
    fd.append('textColor1', textColor1);
    fd.append('textAlign1', textAlign1);
    fd.append('textColor2', textColor2);
    fd.append('textAlign2', textAlign2);
    fd.append('text1X', text1X);
    fd.append('text1Y', text1Y);
    fd.append('text1Size', text1Size);
    fd.append('text1BoxW', text1BoxW);
    fd.append('text2X', text2X);
    fd.append('text2Y', text2Y);
    fd.append('text2Size', text2Size);
    fd.append('text2BoxW', text2BoxW);

    const designName = ((document.getElementById('lw-design-name') || {}).value || '').trim().slice(0, 40);
    fd.append('design_name', designName);

    if (editJobId) {
      fd.append('edit_job_id', editJobId);                // reuse the SKU on edits
    } else if (reservedJobId && reservedVariantId) {
      fd.append('job_id', reservedJobId);                 // pre-minted during design → /save skips the mint
      fd.append('variant_id', reservedVariantId);
    }
    setLoad(T('saving','Saving your design…'));
    const saveRes=await fetch(`${API_BASE}/save`, {method:'POST', body:fd});
    if(!saveRes.ok) throw new Error('Save failed: '+saveRes.status);
    const saveJson=await saveRes.json();
    const jobId=saveJson.job_id;
    const previewUrl=saveJson.preview_url;

    const variantGid = saveJson.variant_id || saveJson.default_variant_id;
    const variantNumericId = Number(variantGid.split('/').pop());

    // Test hook: naming the design BAKTEST downloads the generated 3MF — the file
    // that actually goes to the printer — instead of adding to the cart.
    if (designName.toUpperCase() === 'BAKTEST') {
      setLoad('BAKTEST: generating 3MF (about 2 minutes)…');
      try {
        const g = await fetch(`${API_BASE}/generate-design/${jobId}`, { method: 'POST' }).then(r => r.json());
        const dl = (url, name) => { const a = document.createElement('a'); a.href = url; a.download = name || ''; a.rel = 'noopener'; document.body.appendChild(a); a.click(); a.remove(); };
        if (g.mf_url) dl(g.mf_url, jobId + '.3mf');
        setLoad('BAKTEST: 3MF downloaded — nothing was added to your cart.');
        st.className = 'lw-header-status ok';
      } catch (bakErr) {
        setLoad('BAKTEST generate failed: ' + bakErr.message);
        st.className = 'lw-header-status err';
      }
      btn.disabled = false;
      document.getElementById('lw-confirm-modal').classList.remove('on');
      return;
    }

    setLoad(editCartLineKey ? T('updatingCart','Updating cart…') : T('addingToCart','Adding to cart…'));

    // On an edit the SKU is reused, so remove the old cart line FIRST — re-adding
    // the same variant afterwards would otherwise risk merging into it.
    if (editCartLineKey) {
      await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ id: editCartLineKey, quantity: 0 })
      });
    }

    // Cache-bust the preview so an edited line shows the updated thumbnail.
    const previewProp = previewUrl ? (previewUrl + (previewUrl.includes('?') ? '&' : '?') + 'v=' + Date.now()) : '';
    // The flat production design (photo + baked text), shown beside the 3D render
    // in the confirmation email. Served by the backend /design/<job> endpoint.
    const designImageProp = jobId ? (API_BASE + '/design/' + jobId + '?v=' + Date.now()) : '';
    // Add to cart AND get the re-rendered drawer + count bubble back in ONE request
    // (Shopify's `sections` param), instead of the add + 2 extra section fetches.
    const cartRes=await fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({
        items:[{
          id: variantNumericId,
          quantity: 1,
          properties: {
            '_job_id': jobId,
            // Underscore-prefixed = hidden from Shopify's order-status page / Shop
            // app / emails, but still readable by our cart + email templates and
            // visible to us in the admin. Keeps the customer's order view clean.
            '_preview': previewProp,
            '_design_image': designImageProp,
            ...(designName ? { 'Design name': designName } : {}),
            '_text_line_1': t1 ? t1.value : '',
            '_text_line_2': t2 ? t2.value : '',
          }
        }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    });
    if(!cartRes.ok) throw new Error('Cart failed: '+cartRes.status);
    const cartJson = await cartRes.json();
    const sections = cartJson.sections || {};

    // Update the cart drawer from the section HTML returned by the add call.
    try {
      if (sections['cart-drawer']) {
        const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const newInner = doc.getElementById('CartDrawer');
        const oldInner = document.getElementById('CartDrawer');
        const newOuter = doc.querySelector('cart-drawer');
        const oldOuter = document.querySelector('cart-drawer');
        if (newInner && oldInner) oldInner.innerHTML = newInner.innerHTML;
        if (newOuter && oldOuter) oldOuter.className = newOuter.className;
      }
    } catch (e) { console.error('Cart drawer update failed', e); }

    // Update the header cart-count bubble from the same response.
    try {
      if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.innerHTML = sections['cart-icon-bubble'];
      }
    } catch (e) { console.error('Cart bubble update failed', e); }

    // Non-blocking: keep any other [data-cart-count] displays in sync.
    fetch('/cart.js').then(r=>r.json()).then(cart=>{
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    }).catch(()=>{});

    setLoad(editCartLineKey ? T('designUpdated','Design updated! ✓') : T('addedToCart','Added to cart! ✓'));
    st.className='lw-header-status ok';
    btn.disabled=false;
    document.getElementById('lw-confirm-modal').classList.remove('on');

    // No 3MF/STL generation here. All mesh generation is deferred to a confirmed
    // PAID order (backend orders/paid webhook → submit_print_job). Add-to-cart only
    // saves the design + mints the SKU, so it stays fast and never loads the backend.
    exitAfterEdit();   // cart-page edits → cart page; drawer/fresh → drawer + reset to fresh

  } catch(e) {
    document.getElementById('lw-confirm-spinner').style.display='none';
    document.getElementById('lw-confirm-loading-sub').textContent = e.message;
    document.getElementById('lw-confirm-retry').style.display='';
    loadMsg.textContent=T('cartError','⚠️ Couldn’t add to cart');
    st.textContent='Error: '+e.message; st.className='lw-header-status err'; btn.disabled=false;
  }
};

})();
